<template>

    <div class="main">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>
        <!-- 標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <div class="main-content">
            <!-- 表單及清單 -->
            <div id="plant_register" v-show="!form.isSubmitDone">

                <!-- 表單(使用者驗證) -->
                <div id="plant_form" class="w3-container w3-card-4 w3-light-grey w3-margin">

                    <p class="w3-center header-title">{{ form.title }}</p>

                    <!-- 驗證欄位 姓名 -->
                    <div class="w3-row w3-section">
                        <div class="field w3-col">
                            <i class="w3-xxlarge fa" :class="form.classUserName"></i>
                        </div>
                        <div class="value w3-rest">
                            <input class="w3-input w3-border" :disabled="form.isVerifyDone" v-model="form.valueUserName" type="text" :placeholder="form.placeholderUserName">
                        </div>
                    </div>

                    <!-- 驗證欄位 電話 -->
                    <div class="w3-row w3-section">
                        <div class="field w3-col">
                            <i class="w3-xxlarge fa" :class="form.classUserPhone"></i>
                        </div>
                        <div class="value w3-rest">
                            <input class="w3-input w3-border" :disabled="form.isVerifyDone" v-model="form.valueUserPhone" type="number" :placeholder="form.placeholderUserPhone">
                        </div>
                    </div>

                    <!-- 驗證提示 -->
                    <div v-show="!form.isVerifyDone" class="w3-row w3-section">
                        <div class="field w3-col">
                            &nbsp;
                        </div>
                        <!-- 前端記得電話號碼要擋，至少要7碼，否則他隨便輸入1碼就可以模糊比對成功 -->
                        <div class="value w3-rest" style="text-align: start; color: #FF0000;">
                            請輸入市話6-8碼【無須縣市區號/區碼】或手機10碼。
                        </div>
                    </div>

                    <!-- 按鈕 目前種植情形、驗證 -->
                    <p style="text-align:right;">

                        <!-- 目前種植情形按鈕 -->
                        <button class="w3-button w3-light-green" v-show="true" @click="plantStatistics()">
                            <i class="fa" :class="button.classStatistics" aria-hidden="true"></i> {{ button.labelStatistics }}
                        </button>&nbsp;
                        <!-- 驗證按鈕 -->
                        <button class="w3-button w3-amber" @click="onVerify" v-show="!form.isVerifyDone">
                            <i class="fa" :class="button.classVerify" aria-hidden="true"></i> {{ button.labelVerify }}
                        </button>
                        <!-- 先前登記紀錄按鈕 -->
                        <button class="w3-button w3-light-blue" @click="getAreaRecord" v-show="form.isVerifyDone">
                            <i class="fa" :class="button.classAreaRecord" aria-hidden="true"></i> {{ button.labelAreaRecord }}
                        </button>

                    </p>
                </div>

                <!-- 按鈕 新增、提交 -->
                <p v-show="form.isVerifyDone" class="plant_btns_insert_send">
                    <button class="w3-button w3-teal" @click="onInsert"><i class="fa" :class="button.classAddPlant" aria-hidden="true"></i> {{ button.labelAddPlant }}</button>&nbsp;
                    <button class="w3-button w3-brown" @click="onSubmit"><i class="fa" :class="button.classSubmitPlant" aria-hidden="true"></i> {{ button.labelSubmitPlant }}</button>
                </p>

                <!-- 目前共有 n 筆種植紀錄 -->
                <p class="plant_amount" v-show="form.isVerifyDone && plant.length > 0"> 目前共有 {{ plant.length }} 筆種植紀錄。</p>

                <!-- 清單(已驗證完後才呈現) -->
                <p id="plant_list" v-show="form.isVerifyDone && plant.length > 0">

                    <template v-for="(value, key) in plant">

                        <div class="item w3-khaki w3-hover-shadow w3-center" :key="'item'+key">
                            <div class="w3-row">
                                <div class="w3-col w3-container" style="width: 100%; margin-top: 10px;">

                                    <!-- 第 N 筆紀錄 -->
                                    <p class="header-title">
                                        <span style="float:inline-start;">● 第 {{ key + 1 }} 筆種植紀錄</span>
                                        <i @click="onVisibility(key,!value.Visibility)" class="fa" :class="value.Visibility?'fa-chevron-circle-down':'fa-chevron-circle-up'" style="font-size: x-large;" aria-hidden="true"></i>
                                    </p>
                                    <!-- 新增模式 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">新增模式 : </span>
                                        <span class="value">{{ value.Type == 'User'?'農糧署先前登記紀錄':'雲林縣全部行政區' }}</span>

                                    </p>
                                    <!-- 鄉鎮市區 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelTOWN_ID }}</span>
                                        <span class="value">{{ value.TOWN_NAME }}</span>
                                        <span class="value" v-show="value.Visibility && isDevelop">({{ value.TOWN_ID }})</span>
                                    </p>
                                    <!-- 地段(識別碼) -->
                                    <p class="info" v-show="value.Visibility && isDevelop">
                                        <span class="field">地段(識別碼) : </span>
                                        <span class="value">{{ value.SITESEC_ID }}</span>
                                    </p>
                                    <!-- 地段地號 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelSITESEC_NAME_NUMBER }}</span>
                                        <span class="value">{{ value.SITESEC_NAME }} - {{ value.SITESEC_NUMBER }}</span>
                                    </p>
                                    <!-- 年度 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelA_YEAR }}</span>
                                        <span class="value">{{ value.A_YEAR }}</span>
                                    </p>
                                    <!-- 期作 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelPERIOD }}</span>
                                        <span class="value">{{ value.PERIOD }}</span>
                                    </p>
                                    <!-- 作物種類 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelCROP_ID }}</span>
                                        <span class="value">{{ value.CROP_NAME }}</span>
                                        <span class="value" v-show="value.Visibility && isDevelop">({{ value.CROP_ID }})</span>
                                    </p>
                                    <!-- 土地狀態 -->
                                    <p class="info" v-show="value.Visibility && false">
                                        <span class="field">{{ modal.plant.labelSTATE_P }}</span>
                                        <span class="value">{{ value.STATE_P }}</span>
                                    </p>
                                    <!-- 種植面積 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelAREA_P }}</span>
                                        <span class="value">{{ value.AREA_P }} 公頃</span>
                                    </p>
                                    <!-- 種植日期 -->
                                    <p class="info" v-show="value.Visibility">
                                        <span class="field">{{ modal.plant.labelDATE_P }}</span>
                                        <span class="value">{{ value.DATE_P }}</span>
                                    </p>
                                    <!-- 修改、刪除按鈕 -->
                                    <p style="text-align:right;" v-show="value.Visibility">
                                        <button class="w3-button w3-indigo" @click="onModify(value, key)"><i class="fa" :class="button.classEditPlant" aria-hidden="true"></i> {{ button.labelEditPlant }}</button>&nbsp;
                                        <button class="w3-button w3-red" @click="onDelete(key)"><i class="fa" :class="button.classDelPlant" aria-hidden="true"></i> {{ button.labelDelPlant }}</button>
                                    </p>

                                </div>
                            </div>
                        </div>

                    </template>
                </p>

                <!-- 種植資料為空的提示訊息 -->
                <div id="plant_empty_message" class="w3-panel w3-red w3-border w3-round" v-show="form.isVerifyDone && plant.length == 0">
                    <p class="header-title">
                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ message.plantEmptyTitle }}
                    </p>
                    <p class="description">
                        {{ message.plantEmptyDescription }}
                    </p>
                </div>

            </div>
            <!-- 領取獎勵 -->
            <div id="receive_award" v-show="form.isSubmitDone">
                <!-- QrCode -->
                <div id="qr_code" class="w3-container">
                    <div class="w3-card-4 w3-dark-grey form-style" style="min-height:250px">

                        <div class="w3-container w3-center">
                            <!-- 標題 -->
                            <p class="header-title">
                                {{ message.plantDoneSubmit }}
                            </p>
                            <!-- QrCode圖片 -->
                            <div v-show="false" id="qr_code_img" class="img-body" style="width: 150px;height: 150px;margin: auto;display: block;margin-top: 10px;margin-bottom: 10px;background: #FF0000;"></div>
                            <!-- 手機不支援告知 -->
                            <p v-show="false" class="description" style="color:#FFFF00">
                                目前安卓系統手機無法下載圖片，需請使用者截圖(同時按住電源和調低音量按鈕)。
                            </p>
                            <!-- 簡介 -->
                            <p v-show="false" class="description">
                                {{ message.qrCodeUseReminder }}
                            </p>
                            <p>
                                您此次的種植登記已提交成功，若還有其他作物需做登記，請點選下方"重新登記"按鈕。
                            </p>
                            <!-- 下載圖片、重新登記按鈕 -->
                            <div class="w3-section">
                                <button v-if="false" class="w3-button w3-green" @click="onDownloadQrCode"><i class="fa" :class="button.classDownloadQrCode" aria-hidden="true"></i> {{ button.labelDownloadQrCode }}</button>&nbsp;
                                <button class="w3-button w3-red" @click="onAgainRegister"><i class="fa" :class="button.classAgainRegister" aria-hidden="true"></i> {{ button.labelAgainRegister }}</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 彈出視窗(新增、修改)(已登記) -->
            <div id="dialog_register" class="w3-modal" :style="modal.plant.modalStyleProcess">
                <div class="body w3-modal-content w3-card-4 w3-animate-zoom">

                    <!-- 表頭 (操作動作、關閉視窗按鈕) -->
                    <header class="w3-container" :class="modal.plant.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'">
                        <span @click="modal.plant.modalStyleProcess.display='none'" class="w3-button w3-display-topright">&times;</span>
                        <h5><i class="fa" :class="modal.plant.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant.titleProcessSubmit }}</h5>
                    </header>
                    <!-- 新增模式 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            新增模式:
                        </div>
                        <div class="value w3-col w3-container">
                            <div style="margin-top: 2px;">
                                農糧署先前登記紀錄
                                <button class="w3-button w3-dark-grey w3-small" @click="onSwitch('All')" v-show="modal.plant.moduleProcessSubmit=='add' && !form.isVerifyPass">
                                    <i class="fa" :class="button.classSwitch" aria-hidden="true"></i> {{ button.labelSwitch }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- 鄉鎮市區 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelTOWN_ID }}
                        </div>
                        <div class="value w3-col w3-container">
                            <v-select v-model="modal.plant.valueTOWN_ID" :placeholder="modal.plant.placeholderTOWN_ID" :options="menu.town" :reduce="(option) => option.Value" label="Title" style="width: 160px"></v-select>
                        </div>
                    </div>
                    <!-- 地段 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelSITESEC_NAME }}
                        </div>
                        <div class="value w3-col w3-container">
                            <v-select v-model="modal.plant.valueSITESEC_NAME" :placeholder="modal.plant.placeholderSITESEC_NAME" :options="modal.plant.menuSITESEC_NAME" :reduce="(option) => option.Value" label="Title" style="width: 230px"></v-select>
                        </div>
                    </div>
                    <!-- 地號 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelSITESEC_NUMBER }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 110px;" v-model="modal.plant.valueSITESEC_NUMBER_BEFORE" :disabled="modal.plant.disabledSITESEC_NUMBER" oninput="if(value.length>4)value=value.slice(0,4)" min="0"> -
                            <input type="number" style="width: 110px;" v-model="modal.plant.valueSITESEC_NUMBER_AFTER" :disabled="modal.plant.disabledSITESEC_NUMBER" oninput="if(value.length>4)value=value.slice(0,4)" min="0">
                        </div>
                    </div>
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            &nbsp;
                        </div>
                        <div class="value w3-col w3-container">

                            <span class="required">範例: 大竹圍段 0359-0000</span>
                            <!--
                            <span class="required">{{ modal.plant.valueSITESEC_NUMBER }}</span>
                            -->
                        </div>
                    </div>

                    <!-- 年度 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelA_YEAR }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueA_YEAR" :disabled="modal.plant.disabledA_YEAR" style="width: 160px;">
                                <option value="">
                                    {{ modal.plant.placeholderA_YEAR }}
                                </option>
                                <option v-for="(value, key) in menu.year" :value="value.Value" :key="'valueA_YEAR' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 期作 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelPERIOD }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valuePERIOD" :disabled="modal.plant.disabledPERIOD" style="width: 160px;">
                                <option value="">
                                    {{ modal.plant.placeholderPERIOD }}
                                </option>
                                <option v-for="(value, key) in menu.period" :value="value.Value" :key="'valuePERIOD' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 作物種類 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelCROP_ID }}
                        </div>
                        <div class="value w3-col w3-container" style="max-width: 170px;">
                            <v-select v-model="modal.plant.valueCROP_ID" :placeholder="modal.plant.placeholderCROP_ID" :options="menu.crop" :reduce="(option) => option.Value" label="Title"></v-select>
                        </div>
                    </div>
                    <!-- 土地狀態 -->
                    <div class="w3-row" v-show="false">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelSTATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant.valueSTATE_P" :disabled="modal.plant.disabledSTATE_P" style="width:160px;">
                                <option value="">
                                    {{ modal.plant.placeholderSTATE_P }}
                                </option>
                                <option v-for="(value, key) in menu.state" :value="value.Value" :key="'valueSTATE_P' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 種植面積 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelAREA_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 160px;" :min="modal.plant.minAREA_P" :max="modal.plant.maxAREA_P" v-model="modal.plant.valueAREA_P" :disabled="modal.plant.disabledAREA_P" :placeholder="modal.plant.placeholderAREA_P"> 公頃
                        </div>
                    </div>
                    <div class="w3-row" v-show="modal.plant.maxAREA_P != ''">
                        <div class="field w3-col w3-container">
                            &nbsp;
                        </div>
                        <div class="value w3-col w3-container">
                            <span class="required">種植面積最多可填{{ modal.plant.maxAREA_P }}公頃</span>
                        </div>
                    </div>
                    <!-- 種植日期 -->
                    <div class="w3-row" style=" margin-bottom: 20px;">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant.labelDATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="date" style="width: 160px;" v-model="modal.plant.valueDATE_P" :disabled="modal.plant.disabledDATE_P" :placeholder="modal.plant.placeholderDATE_P">
                        </div>
                    </div>
                    <!-- 表尾 (操作動作、提交按鈕) -->
                    <p>
                        <button class="w3-button w3-block" :class="modal.plant.moduleProcessSubmit=='add'?'w3-teal':'w3-indigo'"  @click="onSava"><i class="fa" :class="modal.plant.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant.btnProcessSubmit }}</button>
                    </p>

                </div>
            </div>

            <!-- 彈出視窗(新增、修改)(未登記) -->
            <div id="dialog_register" class="w3-modal" :style="modal.plant_all.modalStyleProcess">
                <div class="body w3-modal-content w3-card-4 w3-animate-zoom">

                    <!-- 表頭 (操作動作、關閉視窗按鈕) -->
                    <header class="w3-container" :class="modal.plant_all.moduleProcessSubmit=='add'?'w3-green':'w3-indigo'">
                        <span @click="modal.plant_all.modalStyleProcess.display='none'" class="w3-button w3-display-topright">&times;</span>
                        <h5><i class="fa" :class="modal.plant_all.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant_all.titleProcessSubmit }}</h5>
                    </header>
                    <!-- 新增模式 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            新增模式 :
                        </div>
                        <div class="value w3-col w3-container">
                            <div style="margin-top: 2px;">
                                雲林縣全部行政區
                                <button class="w3-button w3-dark-grey w3-small" @click="onSwitch('User')" v-show="modal.plant_all.moduleProcessSubmit=='add' && !form.isVerifyPass">
                                    <i class="fa" :class="button.classSwitch" aria-hidden="true"></i> {{ button.labelSwitch }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- 鄉鎮市區 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelTOWN_ID }}
                        </div>
                        <div class="value w3-col w3-container">
                            <v-select v-model="modal.plant_all.valueTOWN_ID" :placeholder="modal.plant_all.placeholderTOWN_ID" :options="menu.town_all" :reduce="(option) => option.Value" label="Title" style="width: 160px"></v-select>
                        </div>
                    </div>
                    <!-- 地段 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelSITESEC_NAME }}
                        </div>
                        <div class="value w3-col w3-container">
                            <v-select v-model="modal.plant_all.valueSITESEC_NAME" :placeholder="modal.plant_all.placeholderSITESEC_NAME" :options="modal.plant_all.menuSITESEC_NAME" :reduce="(option) => option.Value" label="Title" style="width: 230px"></v-select>
                        </div>
                    </div>
                    <!-- 地號 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelSITESEC_NUMBER }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 110px;" v-model="modal.plant_all.valueSITESEC_NUMBER_BEFORE" :disabled="modal.plant_all.disabledSITESEC_NUMBER" oninput="if(value.length>4)value=value.slice(0,4)" min="0"> -
                            <input type="number" style="width: 110px;" v-model="modal.plant_all.valueSITESEC_NUMBER_AFTER" :disabled="modal.plant_all.disabledSITESEC_NUMBER" oninput="if(value.length>4)value=value.slice(0,4)" min="0">
                        </div>
                    </div>
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            &nbsp;
                        </div>
                        <div class="value w3-col w3-container">

                            <span class="required">範例: 大竹圍段 0359-0000</span>
                            <!--
                            <span class="required">{{ modal.plant_all.valueSITESEC_NUMBER }}</span>
                            -->
                        </div>
                    </div>

                    <!-- 年度 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelA_YEAR }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant_all.valueA_YEAR" :disabled="modal.plant_all.disabledA_YEAR" style="width: 160px;">
                                <option value="">
                                    {{ modal.plant_all.placeholderA_YEAR }}
                                </option>
                                <option v-for="(value, key) in menu.year" :value="value.Value" :key="'valueA_YEAR' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 期作 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelPERIOD }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant_all.valuePERIOD" :disabled="modal.plant_all.disabledPERIOD" style="width: 160px;">
                                <option value="">
                                    {{ modal.plant_all.placeholderPERIOD }}
                                </option>
                                <option v-for="(value, key) in menu.period" :value="value.Value" :key="'valuePERIOD' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 作物種類 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelCROP_ID }}
                        </div>
                        <div class="value w3-col w3-container" style="max-width: 170px;">
                            <v-select v-model="modal.plant_all.valueCROP_ID" :placeholder="modal.plant_all.placeholderCROP_ID" :options="menu.crop" :reduce="(option) => option.Value" label="Title"></v-select>
                        </div>
                    </div>
                    <!-- 土地狀態 -->
                    <div class="w3-row" v-show="false">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelSTATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <select v-model="modal.plant_all.valueSTATE_P" :disabled="modal.plant_all.disabledSTATE_P" style="width:160px;">
                                <option value="">
                                    {{ modal.plant_all.placeholderSTATE_P }}
                                </option>
                                <option v-for="(value, key) in menu.state" :value="value.Value" :key="'valueSTATE_P' + key">
                                    {{ value.Title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!-- 種植面積 -->
                    <div class="w3-row">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelAREA_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="number" style="width: 160px;" :min="modal.plant_all.minAREA_P" :max="modal.plant_all.maxAREA_P" v-model="modal.plant_all.valueAREA_P" :disabled="modal.plant_all.disabledAREA_P" :placeholder="modal.plant_all.placeholderAREA_P"> 公頃
                        </div>
                    </div>
                    <div class="w3-row" v-show="modal.plant_all.maxAREA_P != ''">
                        <div class="field w3-col w3-container">
                            &nbsp;
                        </div>
                        <div class="value w3-col w3-container">
                            <span class="required">種植面積最多可填{{ modal.plant_all.maxAREA_P }}公頃</span>
                        </div>
                    </div>
                    <!-- 種植日期 -->
                    <div class="w3-row" style=" margin-bottom: 20px;">
                        <div class="field w3-col w3-container">
                            <span class="required">*</span>{{ modal.plant_all.labelDATE_P }}
                        </div>
                        <div class="value w3-col w3-container">
                            <input type="date" style="width: 160px;" v-model="modal.plant_all.valueDATE_P" :disabled="modal.plant_all.disabledDATE_P" :placeholder="modal.plant_all.placeholderDATE_P">
                        </div>
                    </div>
                    <!-- 表尾 (操作動作、提交按鈕) -->
                    <p>
                        <button class="w3-button w3-block" :class="modal.plant_all.moduleProcessSubmit=='add'?'w3-green':'w3-indigo'"  @click="onSavaAll"><i class="fa" :class="modal.plant_all.iconProcessSubmit" aria-hidden="true"></i> {{ modal.plant_all.btnProcessSubmit }}</button>
                    </p>

                </div>
            </div>

            <!-- 彈出視窗(種植統計、分布) -->
            <div v-show="modal.statistics.show" class="w3-modal" style="display: block;">
                <div class="w3-modal-content w3-round-large">
                    <div class="w3-container calculation">
                        <!-- 關閉按鈕 -->
                        <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="modal.statistics.show = false;"><span class="icon-cross"></span></span>
                        <!-- 標題 -->
                        <h3 class="modal-title">{{ modal.statistics.title }}</h3>

                        <!-- 圖台 -->
                        <div class="modal-title">{{ modal.statistics.titleMap }}</div>
                        <div class="w3-row">
                            <div class="w3-col w3-container" style="text-align: -webkit-right;">
                                <div id="map"></div>
                            </div>
                        </div>
                        <div class="w3-container">{{ modal.statistics.descriptMap }}</div>
                        <p>&nbsp;</p>

                        <!-- 圖表(種植面積)(行政區) -->
                        <div class="modal-title">{{ modal.statistics.titleChartTown }}</div>
                        <div class="w3-row">
                            <p class="title-sub" style="padding:0px">
                                {{ modal.statistics.titleSubChartTown }}<br />
                                <span style="font-size: 14px;font-weight: 400;">登記種植總面積共{{ modal.statistics.allAreaChartTown }}公頃</span>
                            </p>
                            <div class="w3-col w3-container" style="text-align: -webkit-right;">
                                <div id="chart_crop_area_town"></div>
                            </div>
                        </div>
                        <div class="w3-container">{{ modal.statistics.descriptChartTown }}</div>

                        <!-- 圖表(種植面積)(縣市) -->
                        <div class="modal-title">{{ modal.statistics.titleChartCity }}</div>
                        <div class="w3-row">
                            <p class="title-sub" style="padding:0px">
                                {{ modal.statistics.titleSubChartCity }}<br />
                                <span style="font-size: 14px;font-weight: 400;">登記種植總面積共{{ modal.statistics.allAreaChartCity }}公頃</span>
                            </p>
                            <div class="w3-col w3-container" style="text-align: -webkit-right;">
                                <div id="chart_crop_area_city_town"></div>
                            </div>
                            <div class="w3-col w3-container" style="text-align: -webkit-right;">
                                <div id="chart_crop_area_city_crop"></div>
                            </div>
                        </div>
                        <div class="w3-container">{{ modal.statistics.descriptChartCity }}</div>

                    </div>
                </div>
            </div>

            <!-- 彈出視窗(先前登記紀錄) -->
            <div v-show="modal.record.show" class="w3-modal" style="display: block;">
                <div class="w3-modal-content w3-round-large">
                    <div class="w3-container calculation">
                        <!-- 關閉按鈕 -->
                        <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="modal.record.show = false;"><span class="icon-cross"></span></span>
                        <!-- 標題 -->
                        <h3 class="modal-title">{{ modal.record.title }}</h3>
                        <div class="modal-title">{{ form.valueUserName }}-{{ form.valueUserPhone }}，先前登記紀錄，共有{{ modal.record.menu.length }}筆資料。</div>

                        <div style="overflow-x: auto;">
                            <table class="w3-table w3-striped w3-bordered w3-hoverable" style="width: 100%; min-width: 800px;">
                                <tr>
                                    <th>鄉鎮市區</th>
                                    <th>地段地號</th>
                                    <th>年度</th>
                                    <th>期作</th>
                                    <th>作物種類</th>
                                    <th>種植面積</th>
                                    <th>種植日期</th>
                                    <th>建檔日期</th>
                                </tr>
                                <tr v-for="(value, key) in modal.record.menu" :key="'record' + key" :style="{ backgroundColor: key % 2 === 0 ? '#f2f2f2':'#ffffff'}">
                                    <td>{{ value.TOWN }}</td>
                                    <td>{{ value.SITESEC_NAME }}-{{ value.SITESEC_NUMBER }}</td>
                                    <td>{{ value.A_YEAR }}</td>
                                    <td>{{ value.PERIOD }}</td>
                                    <td>{{ value.CROP }}</td>
                                    <td>{{ value.AREA_P }}公頃</td>
                                    <td>{{ value.DATE_P.split('T')[0] }}</td>
                                    <td>{{ value.CreateTime.split('T')[0] }}</td>
                                </tr>
                            </table>
                        </div>


                    </div>
                </div>
            </div>



        </div>

    </div>

</template>
<script>
import Map from 'ol/Map';
import View from 'ol/View';
import { XYZ,
         Vector as VectorSource,
         //ImageStatic as Static
        } from "ol/source";
import { fromLonLat,
        //transformExtent
        } from "ol/proj";
import { Tile,
         Vector as VectorLayer,
         //Image as ImageLayer,
        } from "ol/layer";
//import KML from "ol/format/KML";
import GeoJSON from "ol/format/GeoJSON";
import {
        Fill,
        Stroke,
        Style
        } from "ol/style";

    export default {
        data() {
            return {

                //api 取得作物清單
                apiGetCropList: (data) => this.userRequest.post("/API/Default/GetCropList", data),
                //api 取得最大種植面積
                apiGetAreaMax: (data) => this.userRequest.post("/API/Default/GetAreaMax", data),
                //api 取得已登記面積
                apiGetAreaUse: (data) => this.userRequest.post("/API/Default/GetAreaUse", data),
                //api 取得先前登記紀錄
                apiGetAreaRecord: (data) => this.userRequest.post("/API/Default/GetAreaRecord", data),


                //api 取得地段清單
                apiGetSecList: (data) => this.userRequest.post("/API/Default/GetSecList", data),
                //api 種植紀錄提交
                apiPlantRegister: (data) => this.userRequest.post("/API/Default/PlantRegister", data),
                //api 種植統計數據
                apiPlantStatistics: (data) => this.userRequest.post("/API/Default/PlantStatistics", data),
                //api 農民身分驗證
                apiVerifyAgriPlantUser: (data) => this.userRequest.post("/API/Default/VerifyAgriPlantUser", data),

                //標題
                title:"種植登記",

                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '種植登記',
                        active: true
                    }
                ],

                //是否是在開發模式
                isDevelop:false,

                //QrCode 兌換頁面網址
                qr_code_url:"https://agri-plus.yunlin.gov.tw/#/ReceivedAward?qr_code=",
                //qr_code_url:"http://localhost:8080/#/ReceivedAward?qr_code=",

                //表單頁面
                form:{

                    title:"雲林縣主產作物農情調查登記系統",

                    labelUserName: "姓名:",
                    //valueUserName: "林建安",
                    valueUserName: "",
                    classUserName: "fa-user",
                    placeholderUserName: "請輸入姓名",

                    labelUserPhone: "聯絡方式:",
                    //valueUserPhone: "0982056837",
                    valueUserPhone: "",
                    classUserPhone: "fa-phone",
                    placeholderUserPhone: "請輸入市話或手機號碼",

                    //是否驗證成功(因為甲方目前無法提供驗證API，暫時改成有輸入就給過)
                    isVerifyDone:false,
                    //isVerifyDone:true,

                    //是否放棄驗證
                    isVerifyPass:false,

                    //驗證資料
                    verify:[],

                    //是否提交成功
                    isSubmitDone:false,
                    //isSubmitDone:true,

                },
                //相關按鈕
                button:{

                    labelStatistics:"目前種植情形",
                    classStatistics:"fa-bar-chart",

                    labelAreaRecord:"先前登記紀錄",
                    classAreaRecord:"fa-list-ol",

                    labelVerify:"驗證",
                    classVerify:"fa-user-circle",

                    labelAddPlant: "新增",
                    classAddPlant:"fa-plus",

                    labelEditPlant: "修改",
                    classEditPlant:"fa-paint-brush",

                    labelDelPlant: "刪除",
                    classDelPlant:"fa-trash",

                    labelSubmitPlant: "提交",
                    classSubmitPlant:"fa-envelope",

                    labelDownloadQrCode: "下載圖片",
                    classDownloadQrCode:"fa-download",

                    labelAgainRegister: "重新登記",
                    classAgainRegister:"fa-refresh",

                    labelSwitch:"切換",
                    classSwitch:"fa-window-restore",

                },
                //種植情況(清單)
                plant:[],
                //彈出視窗
                modal:{

                    //種植情況(已登記)
                    plant:{

                        // 用於 決定彈出視窗呈現或隱藏
                        modalStyleProcess: { display: "none" },

                        // 用於 彈出視窗的動作(add-新增、edit-修改、browse-瀏覽)
                        moduleProcessSubmit: "add",
                        //moduleProcessSubmit: "edit",
                        //moduleProcessSubmit: "browse",
                        // 用於 彈出視窗的標題
                        titleProcessSubmit: "新增",
                        // 用於 彈出視窗的圖示(fa-plus 新增、fa-paint-brush 修改)
                        iconProcessSubmit: "",
                        // 用於 彈出視窗的按鈕名稱
                        btnProcessSubmit: "新增",
                        // 用於 彈出視窗要修改清單上的哪個項目(若是新增他會是-1，若是修改它會是清單上項目的索引值)
                        indexProcessSubmit: -1,

                        labelTOWN_ID: "鄉鎮市區 : ",
                        valueTOWN_ID: "",
                        disabledTOWN_ID: false,
                        placeholderTOWN_ID: "請選擇鄉鎮市區",
                        passWatchTOWN_ID: false,

                        labelSITESEC_NAME: "地段 : ",
                        valueSITESEC_NAME: "",
                        disabledSITESEC_NAME: false,
                        placeholderSITESEC_NAME: "選擇鄉鎮市區帶入地段",
                        passWatchSITESEC_NAME: false,
                        menuSITESEC_NAME:[],

                        labelSITESEC_NUMBER: "地號 : ",
                        valueSITESEC_NUMBER: "",
                        valueSITESEC_NUMBER_BEFORE: "",
                        valueSITESEC_NUMBER_AFTER: "",
                        disabledSITESEC_NUMBER: false,
                        placeholderSITESEC_NUMBER: "選擇地段帶入地號",
                        passWatchSITESEC_NUMBER: false,
                        menuSITESEC_NUMBER:[],

                        labelSITESEC_NAME_NUMBER: "地段地號 : ",

                        labelA_YEAR: "年度 : ",
                        valueA_YEAR: "",
                        disabledA_YEAR: false,
                        placeholderA_YEAR: "請選擇年度",

                        labelSTATE_P: "土地狀態 : ",
                        valueSTATE_P: "",
                        disabledSTATE_P: false,
                        placeholderSTATE_P: "請選擇土地狀態",

                        labelPERIOD: "期作 : ",
                        valuePERIOD: "",
                        disabledPERIOD: false,
                        placeholderPERIOD: "請選擇期作",

                        labelCROP_ID: "作物種類 : ",
                        valueCROP_ID: "",
                        disabledCROP_ID: false,
                        placeholderCROP_ID: "請選擇作物種類",

                        labelAREA_P: "種植面積 : ",
                        valueAREA_P: "",
                        minAREA_P: "0",
                        maxAREA_P: "",
                        disabledAREA_P: false,
                        placeholderAREA_P: "請輸入種植面積",

                        labelDATE_P: "種植日期 : ",
                        valueDATE_P: "",
                        disabledDATE_P: false,
                        placeholderDATE_P: "請選擇種植日期",
                    },

                    //種植情況(未登記)
                    plant_all:{

                        // 用於 決定彈出視窗呈現或隱藏
                        modalStyleProcess: { display: "none" },

                        // 用於 彈出視窗的動作(add-新增、edit-修改、browse-瀏覽)
                        moduleProcessSubmit: "add",
                        //moduleProcessSubmit: "edit",
                        //moduleProcessSubmit: "browse",
                        // 用於 彈出視窗的標題
                        titleProcessSubmit: "新增",
                        // 用於 彈出視窗的圖示(fa-plus 新增、fa-paint-brush 修改)
                        iconProcessSubmit: "",
                        // 用於 彈出視窗的按鈕名稱
                        btnProcessSubmit: "新增",
                        // 用於 彈出視窗要修改清單上的哪個項目(若是新增他會是-1，若是修改它會是清單上項目的索引值)
                        indexProcessSubmit: -1,

                        labelTOWN_ID: "鄉鎮市區 : ",
                        valueTOWN_ID: "",
                        disabledTOWN_ID: false,
                        placeholderTOWN_ID: "請選擇鄉鎮市區",
                        passWatchTOWN_ID: false,

                        labelSITESEC_NAME: "地段 : ",
                        valueSITESEC_NAME: "",
                        disabledSITESEC_NAME: false,
                        placeholderSITESEC_NAME: "選擇鄉鎮市區帶入地段",
                        passWatchSITESEC_NAME: false,
                        menuSITESEC_NAME:[],

                        labelSITESEC_NUMBER: "地號 : ",
                        valueSITESEC_NUMBER: "",
                        valueSITESEC_NUMBER_BEFORE: "",
                        valueSITESEC_NUMBER_AFTER: "",
                        disabledSITESEC_NUMBER: false,
                        placeholderSITESEC_NUMBER: "選擇地段帶入地號",
                        passWatchSITESEC_NUMBER: false,
                        menuSITESEC_NUMBER:[],

                        labelSITESEC_NAME_NUMBER: "地段地號 : ",

                        labelA_YEAR: "年度 : ",
                        valueA_YEAR: "",
                        disabledA_YEAR: false,
                        placeholderA_YEAR: "請選擇年度",

                        labelSTATE_P: "土地狀態 : ",
                        valueSTATE_P: "",
                        disabledSTATE_P: false,
                        placeholderSTATE_P: "請選擇土地狀態",

                        labelPERIOD: "期作 : ",
                        valuePERIOD: "",
                        disabledPERIOD: false,
                        placeholderPERIOD: "請選擇期作",

                        labelCROP_ID: "作物種類 : ",
                        valueCROP_ID: "",
                        disabledCROP_ID: false,
                        placeholderCROP_ID: "請選擇作物種類",

                        labelAREA_P: "種植面積 : ",
                        valueAREA_P: "",
                        minAREA_P: "0",
                        maxAREA_P: "",
                        disabledAREA_P: false,
                        placeholderAREA_P: "請輸入種植面積",

                        labelDATE_P: "種植日期 : ",
                        valueDATE_P: "",
                        disabledDATE_P: false,
                        placeholderDATE_P: "請選擇種植日期",
                    },

                    //種植統計、分布(有地圖)
                    statistics:{

                        //是否呈現
                        show:false,
                        //標題
                        title:"登記資料統計圖表",
                        //標題(圖台)
                        titleMap:"登記區域分布圖",
                        //標題(圖表)(行政區)
                        titleChartTown:"種植總面積(排序)",
                        //標題(圖表)(縣市)
                        titleChartCity:"種植總面積(排序)",
                        //子標題(圖表)(行政區)
                        titleSubChartTown:"",
                        //子標題(圖表)(縣市)
                        titleSubChartCity:"",
                        //總面積(圖表)(行政區)
                        allAreaChartTown:0,
                        //總面積(圖表)(縣市)
                        allAreaChartCity:0,
                        //簡介
                        descript:"相關簡介",
                        //簡介(圖台)
                        descriptMap:"請點選圖台上的行政區，切換該行政區的種植面積圖表統計。",
                        //簡介(圖表)(行政區)
                        descriptChartTown:"",
                        //簡介(圖表)(縣市)
                        descriptChartCity:"",

                    },

                    //先前登記紀錄
                    record:{

                        //是否呈現
                        show:false,
                        //標題
                        title:"先前登記資料",
                        //清單資料
                        menu:[],
                    },

                },
                //選單
                menu:{
                    //年度
                    year:[],
                    //期作
                    period:[],
                    //土地狀態
                    state:[],
                    //行政區(已登記)
                    town:[],
                    //行政區(未登記)
                    town_all:[],
                    //作物種類
                    crop:[]
                },
                //訊息
                message:{

                    //表單驗證成功
                    verifyDone:"驗證成功，請從下方輸入您的種植作物、日期、面積。",
                    //表單驗證失敗
                    verifyError:"驗證失敗，請確認【姓名】及【聯絡方式】欄位是否輸入正確。",
                    //種植資料為空(標題)
                    plantEmptyTitle:"目前沒有任何種植紀錄",
                    //種植資料為空(敘述)
                    plantEmptyDescription:"請點選新增按鈕，選擇鄉鎮市區、地段、地號後，輸入您的種植情形。",
                    //種植資料為空(警告)
                    plantEmptyAlert:"目前沒有任何種植紀錄，無法提交，至少需要一筆資料。",
                    //種植資料刪除確認
                    plantConfirmDelete:"您確定要刪除這筆資料?",
                    //種植資料提交確認
                    plantConfirmSubmit:"您確定要提交資料?",
                    //種植資料提交但帳號尚未驗證
                    plantSubmitVerifyNone:"帳號尚未驗證，無法提交資料",
                    //種植資料提交成功
                    plantDoneSubmit:"登記成功",

                    //QrCode使用提醒
                    qrCodeUseReminder:"請保留這張QrCode的圖片，持圖片前去相關農會，會有專人替您掃描QrCode，確認無誤後領取獎勵。",
                    //QrCode重新登記確認
                    qrCodeConfirmAgainRegister:"是否已將QrCode圖片下載留存，您確認要重新登記?",

                },
                //OpenLayers 相關物件
                //備註:因為地圖物件，會用到很多變數，所以統一，所有的地圖變數都宣告在 openLayers 物件內
                //備註:如果沒有特定的初始值，統一用null以方便外部去做判別
                openLayers:{

                    //地圖物件
                    Map:null,
                    //地圖預設值
                    Default:
                    {
                        //容器的ID
                        Target:'map',
                        //緯度
                        CenterLat:23.652574754046682,
                        //經度
                        CenterLng:120.36276133502504,
                        //TWD97X
                        TWD97X:184992.53879376827,
                        //TWD97Y
                        TWD97Y:2616692.675353226,
                        //視野(Zoom)
                        Zoom:10,
                    },
                    //圖層
                    Layer:{

                        Tile:{
                            //正射影像圖(通用)
                            PHOTO2:null,
                            //臺灣通用電子地圖(無鐵公路)
                            EMAP9:null,
                            //村里界圖
                            Village:null
                        },
                        //雲林行政區
                        YunlinTown:null,
                    },
                    //樣式
                    Style:{

                        //雲林行政區
                        YunlinTown:function(feature){

                            const _this = window.vue._data;
                            var index = -1;
                            for(var i=0 ; i<_this.openLayers.Data.YunlinTown.length ; i++)
                            {
                                //若有在清單內，才呈現
                                if(_this.openLayers.Data.YunlinTown[i].TOWN_ID == feature.values_.County_ID)
                                {
                                    index = i;
                                }
                            }

                            //若不在選單內的則不呈現
                            if(index == -1){ return null; }


                            var color = "29, 151, 108";
                            var fill_color = "rgba(0, 0, 0, 0)";
                            var max_area = Number(_this.openLayers.Data.YunlinTown[0].AREA_P);
                            var area = Number(_this.openLayers.Data.YunlinTown[index].AREA_P);

                            if( area >= Number(((max_area * 5)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.8)"; }
                            else if( area >= Number(((max_area * 4)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.6)"; }
                            else if( area >= Number(((max_area * 3)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.4)"; }
                            else if( area >= Number(((max_area * 2)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.3)"; }
                            else if( area >= Number(((max_area * 1)/5).toFixed(2)) ) { fill_color = "rgba(" + color + ", 0.2)"; }
                            else { fill_color = "rgba(" + color + ", 0.1)"; }

                            if(_this.openLayers.Select.YunlinTown == feature.values_.County_ID)
                            {
                                //已選取
                                return new Style({

                                    //區塊外框線
                                    stroke: new Stroke({
                                        //外框線顏色
                                        color: "#FF0000",
                                        //外框線寬度
                                        width: 2
                                    }),

                                    //區塊樣式
                                    fill: new Fill({
                                        color: fill_color,
                                    }),

                                    //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                    zIndex: 11001,   //備註 zIndex 越大會越上層
                                });

                            }else{

                                //未選取
                                return new Style({

                                    //區塊外框線
                                    stroke: new Stroke({
                                        //外框線顏色
                                        color: "#000000",
                                        //外框線寬度
                                        width: 2
                                    }),

                                    //區塊樣式
                                    fill: new Fill({
                                        color: fill_color,
                                    }),

                                    //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                    zIndex: 11000,   //備註 zIndex 越大會越上層
                                });

                            }
                        },
                    },
                    //目前選擇
                    Select:{
                        YunlinTown:null,
                    },
                    //資料數據
                    Data:{

                        YunlinCity:null,
                        //範本資料
                        /*
                        YunlinTown:[

                            {
                                TOWN:"虎尾鎮",
                                TOWN_ID:"P03",
                                A_YEAR:113,
                                AREA_P:1.66,
                                CROP:[
                                    {
                                        NAME:"休耕",
                                        ID:"-1",
                                        AREA_P:0.58
                                    },
                                    {
                                        NAME:"粟",
                                        ID:"004",
                                        AREA_P:0.2
                                    },
                                    {
                                        NAME:"硬質玉米",
                                        ID:"001",
                                        AREA_P:0.19
                                    },
                                    {
                                        NAME:"食用玉米",
                                        ID:"002",
                                        AREA_P:0.185
                                    },
                                    {
                                        NAME:"小麥",
                                        ID:"003",
                                        AREA_P:0.182
                                    },
                                    {
                                        NAME:"蕎麥",
                                        ID:"008",
                                        AREA_P:0.16
                                    },
                                    {
                                        NAME:"蜀黍(高粱)",
                                        ID:"005",
                                        AREA_P:0.16
                                    },
                                ]
                            },
                            {
                                TOWN:"斗六市",
                                TOWN_ID:"P01",
                                A_YEAR:113,
                                AREA_P:3.97,
                                CROP:[
                                    {
                                        NAME:"粟",
                                        ID:"004",
                                        AREA_P:1.3
                                    },
                                    {
                                        NAME:"硬質玉米",
                                        ID:"001",
                                        AREA_P:1.29
                                    },
                                    {
                                        NAME:"休耕",
                                        ID:"-1",
                                        AREA_P:0.8
                                    },
                                    {
                                        NAME:"小麥",
                                        ID:"003",
                                        AREA_P:0.18
                                    },
                                    {
                                        NAME:"蜀黍(高粱)",
                                        ID:"005",
                                        AREA_P:0.17
                                    },
                                    {
                                        NAME:"食用玉米",
                                        ID:"002",
                                        AREA_P:0.12
                                    },
                                    {
                                        NAME:"蕎麥",
                                        ID:"008",
                                        AREA_P:0.11
                                    },

                                ]
                            },
                            {
                                TOWN:"大埤鄉",
                                TOWN_ID:"P08",
                                A_YEAR:113,
                                AREA_P:12.28,
                                CROP:[
                                    {
                                        NAME:"休耕",
                                        ID:"-1",
                                        AREA_P:3.2
                                    },
                                    {
                                        NAME:"蕎麥",
                                        ID:"008",
                                        AREA_P:2.8
                                    },
                                    {
                                        NAME:"硬質玉米",
                                        ID:"001",
                                        AREA_P:2.4
                                    },
                                    {
                                        NAME:"食用玉米",
                                        ID:"002",
                                        AREA_P:1.8
                                    },
                                    {
                                        NAME:"粟",
                                        ID:"004",
                                        AREA_P:1.1
                                    },
                                    {
                                        NAME:"蜀黍(高粱)",
                                        ID:"005",
                                        AREA_P:0.8
                                    },
                                    {
                                        NAME:"小麥",
                                        ID:"003",
                                        AREA_P:0.182
                                    },
                                ]
                            },
                            {
                                TOWN:"林內鄉",
                                TOWN_ID:"P10",
                                A_YEAR:113,
                                AREA_P:1.66,
                                CROP:[
                                    {
                                        NAME:"休耕",
                                        ID:"-1",
                                        AREA_P:0.58
                                    },
                                    {
                                        NAME:"粟",
                                        ID:"004",
                                        AREA_P:0.2
                                    },
                                    {
                                        NAME:"硬質玉米",
                                        ID:"001",
                                        AREA_P:0.19
                                    },
                                    {
                                        NAME:"食用玉米",
                                        ID:"002",
                                        AREA_P:0.185
                                    },
                                    {
                                        NAME:"小麥",
                                        ID:"003",
                                        AREA_P:0.182
                                    },
                                    {
                                        NAME:"蕎麥",
                                        ID:"008",
                                        AREA_P:0.16
                                    },
                                    {
                                        NAME:"蜀黍(高粱)",
                                        ID:"005",
                                        AREA_P:0.16
                                    },
                                ]
                            },
                        ]
                        */
                        YunlinTown:[]
                    },
                },

                //圖表延遲(毫秒)
                delay_ms_chart:1250,
                timeout_id_chart_town:-1,
                timeout_id_chart_city_crop:-1,
                timeout_id_chart_city_town:-1,
            }
        },
        watch: {

            //彈跳視窗-鄉鎮市區(已登記)
            "modal.plant.valueTOWN_ID":function(val)
            {
                if(val == null){ val=""; }
                if(val == "")
                {
                    window.vue.modal.plant.valueSITESEC_NAME = "";
                    window.vue.modal.plant.valueSITESEC_NUMBER_BEFORE = "";
                    window.vue.modal.plant.valueSITESEC_NUMBER_AFTER = "";
                    window.vue.modal.plant.maxAREA_P = "";
                    window.vue.modal.plant.menuSITESEC_NAME = [];
                    window.vue.modal.plant.menuSITESEC_NUMBER = [];
                }

                if(this.modal.plant.passWatchTOWN_ID)
                {
                    this.modal.plant.passWatchTOWN_ID = false;
                    return false;
                }

                if(val != "" && this.modal.plant.modalStyleProcess.display.toLowerCase() == "block")
                {
                    var item = this.getMenuInfo("town",val);
                    if(item != null)
                    {
                        //取得該鄉鎮市區地段清單
                        this.getSecList(val);
                    }
                }
            },

            //彈跳視窗-鄉鎮市區(未登記)
            "modal.plant_all.valueTOWN_ID":function(val)
            {
                if(val == null){ val=""; }
                if(val == "")
                {
                    window.vue.modal.plant_all.valueSITESEC_NAME = "";
                    window.vue.modal.plant_all.valueSITESEC_NUMBER_BEFORE = "";
                    window.vue.modal.plant_all.valueSITESEC_NUMBER_AFTER = "";
                    window.vue.modal.plant_all.maxAREA_P = "";
                    window.vue.modal.plant_all.menuSITESEC_NAME = [];
                    window.vue.modal.plant_all.menuSITESEC_NUMBER = [];
                }

                if(this.modal.plant_all.passWatchTOWN_ID)
                {
                    this.modal.plant_all.passWatchTOWN_ID = false;
                    return false;
                }

                if(val != "" && this.modal.plant_all.modalStyleProcess.display.toLowerCase() == "block")
                {
                    var item = this.getMenuInfo("town_all",val);
                    if(item != null)
                    {
                        //取得該鄉鎮市區地段清單
                        this.getSecListAll(val);
                    }
                }
            },

            //彈跳視窗-地段(已登記)
            "modal.plant.valueSITESEC_NAME":function(val)
            {
                if(val == null){ val=""; }
                if(val == "")
                {
                    window.vue.modal.plant.valueSITESEC_NUMBER = "";
                    window.vue.modal.plant.valueSITESEC_NUMBER_BEFORE = "";
                    window.vue.modal.plant.valueSITESEC_NUMBER_AFTER = "";
                    window.vue.modal.plant.maxAREA_P = "";
                    window.vue.modal.plant.menuSITESEC_NUMBER = [];
                }

                if(this.modal.plant.passWatchSITESEC_NAME)
                {
                    this.modal.plant.passWatchSITESEC_NAME = false;
                    return false;
                }

                if(val != "" && this.modal.plant.modalStyleProcess.display.toLowerCase() == "block")
                {
                    var item_sitesec_name = this.getMenuInfo("modal.plant.menuSITESEC_NAME",val);
                    this.getAreaMax(item_sitesec_name.SITESEC_CODE,this.modal.plant.valueSITESEC_NUMBER);
                }
            },

            //彈跳視窗-地號(已登記)
            "modal.plant.valueSITESEC_NUMBER":function(val)
            {
                if(val == "")
                {
                    window.vue.modal.plant.maxAREA_P = "";
                }

                if(this.modal.plant.passWatchSITESEC_NUMBER)
                {
                    this.modal.plant.passWatchSITESEC_NUMBER = false;
                    return false;
                }

                if(val != "" && this.modal.plant.modalStyleProcess.display.toLowerCase() == "block")
                {
                    window.vue.modal.plant.maxAREA_P = "";
                    var item_sitesec_name = this.getMenuInfo("modal.plant.menuSITESEC_NAME",this.modal.plant.valueSITESEC_NAME);
                    if(item_sitesec_name != null && val.length == 8)
                    {
                        this.getAreaMax(item_sitesec_name.SITESEC_CODE,val);
                    }

                }
            },

            //彈跳視窗-地號前四碼(已登記)
            "modal.plant.valueSITESEC_NUMBER_BEFORE":function()
            {
                this.modal.plant.valueSITESEC_NUMBER = this.modal.plant.valueSITESEC_NUMBER_BEFORE + "" + this.modal.plant.valueSITESEC_NUMBER_AFTER;
            },
            //彈跳視窗-地號後四碼(已登記)
            "modal.plant.valueSITESEC_NUMBER_AFTER":function()
            {
                this.modal.plant.valueSITESEC_NUMBER = this.modal.plant.valueSITESEC_NUMBER_BEFORE + "" + this.modal.plant.valueSITESEC_NUMBER_AFTER;
            },

            //彈跳視窗-地號前四碼(未登記)
            "modal.plant_all.valueSITESEC_NUMBER_BEFORE":function()
            {
                this.modal.plant_all.valueSITESEC_NUMBER = this.modal.plant_all.valueSITESEC_NUMBER_BEFORE + "" + this.modal.plant_all.valueSITESEC_NUMBER_AFTER;
            },
            //彈跳視窗-地號後四碼(未登記)
            "modal.plant_all.valueSITESEC_NUMBER_AFTER":function()
            {
                this.modal.plant_all.valueSITESEC_NUMBER = this.modal.plant_all.valueSITESEC_NUMBER_BEFORE + "" + this.modal.plant_all.valueSITESEC_NUMBER_AFTER;
            },

            //彈出視窗的狀態(已登記)
            "modal.plant.modalStyleProcess.display":function(val){

                if(val.toLowerCase() != "block")
                {
                    //關閉
                    this.onClearModalProcess();
                }
                else
                {
                    //打開
                }
            },

            //彈出視窗的狀態(未登記)
            "modal.plant_all.modalStyleProcess.display":function(val){

                if(val.toLowerCase() != "block")
                {
                    //關閉
                    this.onClearModalProcessAll();
                }
                else
                {
                    //打開
                }
            },

        },
        mounted(){
            this.addUserActionLog({

                TokenID:sessionStorage.getItem("TokenID"),
                WebPage:"主產作物登記",
                WebAction:"走訪"
            });
            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

            //初始地圖
            this.initMap();
            //取得各選單
            this.getMenuList();

        },
        created() {

        },
        destroyed() {

        },
        methods: {

            //啟用遮罩
            enableDefaultLoad:function()
            {
                this.enableMask();
                this.default_load = true;
            },
            //取消遮罩
            disableDefaultLoad:function()
            {
                //暫時先設定延遲，否則watch會重複觸發
                const _this = this;
                window.ThreadTool.Delay(function(){

                    _this.disableMask();
                    _this.default_load = false;

                },this.delay_ms_api);
            },
            //是否為空的欄位
            isEmptyValue: function(value){

                var state = false;

                if(value == '')
                {
                    state = true;
                }

                return state;
            },
            //取得選單資訊
            getMenuList:function(){

                //暫時先寫死，承辦有提出作物清單，有的作物是資料表沒有的
                //this.getCropList();
                this.menu.year = [];
                var year = new Date().getFullYear();
                year = year - 1911;
                for(var i=year ; i >= (year-10) ; i--)
                {
                    this.menu.year.push({Title:i,Value:i});
                }

                this.menu.state = [];
                this.menu.state.push({Title:"休耕",Value:"休耕"});
                this.menu.state.push({Title:"種植",Value:"種植"});

                this.menu.period = [];
                this.menu.period.push({Title:"一期作",Value:"一期作"});
                this.menu.period.push({Title:"二期作",Value:"二期作"});
                this.menu.period.push({Title:"裡作",Value:"裡作"});

                this.menu.town_all = [];
                this.menu.town_all.push({ Title:"斗六市",Value:"P01" });
                this.menu.town_all.push({ Title:"斗南鎮",Value:"P02" });
                this.menu.town_all.push({ Title:"虎尾鎮",Value:"P03" });
                this.menu.town_all.push({ Title:"西螺鎮",Value:"P04" });
                this.menu.town_all.push({ Title:"土庫鎮",Value:"P05" });
                this.menu.town_all.push({ Title:"北港鎮",Value:"P06" });
                this.menu.town_all.push({ Title:"古坑鄉",Value:"P07" });
                this.menu.town_all.push({ Title:"大埤鄉",Value:"P08" });
                this.menu.town_all.push({ Title:"莿桐鄉",Value:"P09" });
                this.menu.town_all.push({ Title:"林內鄉",Value:"P10" });
                this.menu.town_all.push({ Title:"二崙鄉",Value:"P11" });
                this.menu.town_all.push({ Title:"崙背鄉",Value:"P12" });
                this.menu.town_all.push({ Title:"麥寮鄉",Value:"P13" });
                this.menu.town_all.push({ Title:"東勢鄉",Value:"P14" });
                this.menu.town_all.push({ Title:"褒忠鄉",Value:"P15" });
                this.menu.town_all.push({ Title:"臺西鄉",Value:"P16" });
                this.menu.town_all.push({ Title:"元長鄉",Value:"P17" });
                this.menu.town_all.push({ Title:"四湖鄉",Value:"P18" });
                this.menu.town_all.push({ Title:"口湖鄉",Value:"P19" });
                this.menu.town_all.push({ Title:"水林鄉",Value:"P20" });

                this.menu.crop = [];
                this.menu.crop.push({ Title:"休耕",Value:"-1" });
                this.menu.crop.push({ Title:"梗稻(水稻)",Value:"C02" });
                this.menu.crop.push({ Title:"秈稻(水稻)",Value:"C03" });
                this.menu.crop.push({ Title:"落花生",Value:"102" });
                this.menu.crop.push({ Title:"甘藷",Value:"201" });
                this.menu.crop.push({ Title:"食用玉米",Value:"002" });
                this.menu.crop.push({ Title:"硬質玉米",Value:"001" });
                this.menu.crop.push({ Title:"大豆",Value:"101" });
                this.menu.crop.push({ Title:"蜀黍(高粱)",Value:"005" });
                this.menu.crop.push({ Title:"馬鈴薯",Value:"203" });
                this.menu.crop.push({ Title:"小麥",Value:"003" });
                this.menu.crop.push({ Title:"蘿蔔",Value:"416" });
                this.menu.crop.push({ Title:"胡蘿蔔",Value:"417" });
                this.menu.crop.push({ Title:"甘藍",Value:"419" });
                this.menu.crop.push({ Title:"大蒜(蒜頭)",Value:"437" });
                this.menu.crop.push({ Title:"蔥",Value:"438" });
                this.menu.crop.push({ Title:"蔥頭",Value:"439" });
                this.menu.crop.push({ Title:"食用番茄",Value:"425" });
                this.menu.crop.push({ Title:"西瓜",Value:"410" });
                this.menu.crop.push({ Title:"木瓜",Value:"627" });
                this.menu.crop.push({ Title:"文旦柚",Value:"607" });
                this.menu.crop.push({ Title:"茂谷柑",Value:"615" });
                this.menu.crop.push({ Title:"番石榴",Value:"623" });
                this.menu.crop.push({ Title:"香蕉",Value:"601" });
                this.menu.crop.push({ Title:"咖啡",Value:"337" });
                this.menu.crop.push({ Title:"生食甘蔗",Value:"306" });
                this.menu.crop.push({ Title:"抱子甘藍",Value:"420" });
                this.menu.crop.push({ Title:"結球白菜",Value:"421" });
                this.menu.crop.push({ Title:"不結球白菜",Value:"422" });
                this.menu.crop.push({ Title:"青蒜",Value:"436" });
                this.menu.crop.push({ Title:"洋蔥",Value:"415" });
                this.menu.crop.push({ Title:"茶",Value:"305" });
                this.menu.crop.push({ Title:"青割玉米",Value:"D13" });
                this.menu.crop.push({ Title:"牧草",Value:"D17" });
                this.menu.crop.push({ Title:"原料甘蔗",Value:"D08" });
                this.menu.crop.push({ Title:"芋頭",Value:"440" });
                this.menu.crop.push({ Title:"薑",Value:"441" });
                this.menu.crop.push({ Title:"荸薺",Value:"442" });
                this.menu.crop.push({ Title:"蓮藕",Value:"443" });
                this.menu.crop.push({ Title:"結頭菜",Value:"444" });
                this.menu.crop.push({ Title:"蕗蕎",Value:"445" });
                this.menu.crop.push({ Title:"其他雜糧",Value:"99" });
                this.menu.crop.push({ Title:"花豆",Value:"103" });
                this.menu.crop.push({ Title:"米豆",Value:"106" });
                this.menu.crop.push({ Title:"蠶豆",Value:"107" });
                this.menu.crop.push({ Title:"紅豆",Value:"104" });
                this.menu.crop.push({ Title:"綠豆",Value:"105" });
                this.menu.crop.push({ Title:"胡麻(芝麻)",Value:"301" });
                this.menu.crop.push({ Title:"棉花",Value:"302" });
                this.menu.crop.push({ Title:"向日葵",Value:"303" });
                this.menu.crop.push({ Title:"油菜子",Value:"304" });
                this.menu.crop.push({ Title:"其他豆類",Value:"199" });
                this.menu.crop.push({ Title:"樹薯",Value:"202" });
                this.menu.crop.push({ Title:"四川榨菜",Value:"446" });
                this.menu.crop.push({ Title:"大心芥菜",Value:"447" });
                this.menu.crop.push({ Title:"慈菇",Value:"448" });
                this.menu.crop.push({ Title:"其他莖菜",Value:"455" });
                this.menu.crop.push({ Title:"大芥菜",Value:"456" });
                this.menu.crop.push({ Title:"蕹菜",Value:"457" });
                this.menu.crop.push({ Title:"芹菜",Value:"458" });
                this.menu.crop.push({ Title:"菠菜",Value:"459" });
                this.menu.crop.push({ Title:"萵苣",Value:"460" });
                this.menu.crop.push({ Title:"莧菜",Value:"461" });
                this.menu.crop.push({ Title:"茼蒿",Value:"462" });
                this.menu.crop.push({ Title:"香芹菜",Value:"463" });
                this.menu.crop.push({ Title:"芫荽",Value:"464" });
                this.menu.crop.push({ Title:"芥藍",Value:"465" });
                this.menu.crop.push({ Title:"茴香",Value:"466" });
                this.menu.crop.push({ Title:"吉康菜",Value:"467" });
                this.menu.crop.push({ Title:"其他葉菜",Value:"470" });
                this.menu.crop.push({ Title:"花椰菜",Value:"471" });
                this.menu.crop.push({ Title:"青花菜",Value:"472" });
                this.menu.crop.push({ Title:"胡瓜",Value:"473" });
                this.menu.crop.push({ Title:"越瓜",Value:"474" });
                this.menu.crop.push({ Title:"冬瓜",Value:"475" });
                this.menu.crop.push({ Title:"苦瓜",Value:"476" });
                this.menu.crop.push({ Title:"茄子",Value:"477" });
                this.menu.crop.push({ Title:"菜豆(豇豆)",Value:"478" });
                this.menu.crop.push({ Title:"契作毛豆",Value:"479" });
                this.menu.crop.push({ Title:"豌豆",Value:"480" });
                this.menu.crop.push({ Title:"甜椒",Value:"481" });
                this.menu.crop.push({ Title:"辣椒",Value:"482" });
                this.menu.crop.push({ Title:"南瓜",Value:"483" });
                this.menu.crop.push({ Title:"佛手瓜",Value:"484" });
                this.menu.crop.push({ Title:"節瓜(毛瓜)",Value:"485" });
                this.menu.crop.push({ Title:"皇帝豆",Value:"486" });
                this.menu.crop.push({ Title:"扁蒲",Value:"487" });
                this.menu.crop.push({ Title:"絲瓜",Value:"488" });
                this.menu.crop.push({ Title:"黃秋葵",Value:"489" });
                this.menu.crop.push({ Title:"鵲豆(肉豆)",Value:"490" });
                this.menu.crop.push({ Title:"關刀豆",Value:"491" });
                this.menu.crop.push({ Title:"菱角",Value:"492" });
                this.menu.crop.push({ Title:"四季豆",Value:"493" });
                this.menu.crop.push({ Title:"田菁",Value:"502" });
                this.menu.crop.push({ Title:"太陽麻",Value:"508" });
                this.menu.crop.push({ Title:"油菜",Value:"509" });
                this.menu.crop.push({ Title:"鐵虎豆",Value:"510" });
                this.menu.crop.push({ Title:"青皮豆",Value:"513" });
                this.menu.crop.push({ Title:"鳳梨",Value:"602" });
                this.menu.crop.push({ Title:"椪柑",Value:"603" });
                this.menu.crop.push({ Title:"柳橙",Value:"604" });
                this.menu.crop.push({ Title:"桶柑",Value:"605" });
                this.menu.crop.push({ Title:"白柚",Value:"609" });
                this.menu.crop.push({ Title:"檸檬",Value:"611" });
                this.menu.crop.push({ Title:"葡萄柚",Value:"612" });
                this.menu.crop.push({ Title:"金柑",Value:"613" });
                this.menu.crop.push({ Title:"四季桔",Value:"616" });
                this.menu.crop.push({ Title:"其他柑桔",Value:"618" });
                this.menu.crop.push({ Title:"龍眼",Value:"619" });
                this.menu.crop.push({ Title:"本地種芒果",Value:"620" });
                this.menu.crop.push({ Title:"改良種芒果",Value:"621" });
                this.menu.crop.push({ Title:"檳榔",Value:"622" });
                this.menu.crop.push({ Title:"粟",Value:"004" });
                this.menu.crop.push({ Title:"大麥",Value:"006" });
                this.menu.crop.push({ Title:"黍",Value:"007" });
                this.menu.crop.push({ Title:"蕎麥",Value:"008" });
                this.menu.crop.push({ Title:"薏苡",Value:"009" });
                this.menu.crop.push({ Title:"採種用蔬菜",Value:"400" });
                this.menu.crop.push({ Title:"蘆筍",Value:"401" });
                this.menu.crop.push({ Title:"韭菜",Value:"402" });
                this.menu.crop.push({ Title:"竹筍",Value:"403" });
                this.menu.crop.push({ Title:"金針菜",Value:"404" });
                this.menu.crop.push({ Title:"山蕨",Value:"405" });
                this.menu.crop.push({ Title:"龍鬚菜",Value:"406" });
                this.menu.crop.push({ Title:"山蘇",Value:"407" });
                this.menu.crop.push({ Title:"洋香瓜",Value:"411" });
                this.menu.crop.push({ Title:"香瓜",Value:"412" });
                this.menu.crop.push({ Title:"瓜子瓜",Value:"413" });
                this.menu.crop.push({ Title:"草莓",Value:"414" });
                this.menu.crop.push({ Title:"茭白筍",Value:"418" });
                this.menu.crop.push({ Title:"加工番茄",Value:"426" });
                this.menu.crop.push({ Title:"豆薯",Value:"430" });
                this.menu.crop.push({ Title:"牛蒡",Value:"431" });
                this.menu.crop.push({ Title:"其他根菜",Value:"435" });
                this.menu.crop.push({ Title:"其他特作",Value:"D10" });
                this.menu.crop.push({ Title:"其他蔬菜",Value:"D12" });
                this.menu.crop.push({ Title:"瓊麻",Value:"307" });
                this.menu.crop.push({ Title:"香水茅",Value:"308" });
                this.menu.crop.push({ Title:"洛神葵",Value:"309" });
                this.menu.crop.push({ Title:"貴黍",Value:"310" });
                this.menu.crop.push({ Title:"仙草",Value:"311" });
                this.menu.crop.push({ Title:"紫蘇",Value:"312" });
                this.menu.crop.push({ Title:"圓藺草",Value:"313" });
                this.menu.crop.push({ Title:"其他短期特作",Value:"320" });
                this.menu.crop.push({ Title:"大甲藺",Value:"321" });
                this.menu.crop.push({ Title:"三角藺",Value:"322" });
                this.menu.crop.push({ Title:"茉莉",Value:"323" });
                this.menu.crop.push({ Title:"秀英",Value:"324" });
                this.menu.crop.push({ Title:"杭菊",Value:"325" });
                this.menu.crop.push({ Title:"油茶",Value:"326" });
                this.menu.crop.push({ Title:"亞麻",Value:"327" });
                this.menu.crop.push({ Title:"苧麻",Value:"328" });
                this.menu.crop.push({ Title:"荖藤",Value:"329" });
                this.menu.crop.push({ Title:"荖花",Value:"330" });
                this.menu.crop.push({ Title:"荖葉",Value:"331" });
                this.menu.crop.push({ Title:"甜菊",Value:"332" });
                this.menu.crop.push({ Title:"羅勒",Value:"333" });
                this.menu.crop.push({ Title:"山葵",Value:"334" });
                this.menu.crop.push({ Title:"黃梔",Value:"335" });
                this.menu.crop.push({ Title:"葛藤",Value:"336" });
                this.menu.crop.push({ Title:"通草",Value:"338" });
                this.menu.crop.push({ Title:"愛玉子",Value:"339" });
                this.menu.crop.push({ Title:"南薑",Value:"340" });
                this.menu.crop.push({ Title:"其他長期特作",Value:"399" });
                this.menu.crop.push({ Title:"其他果菜",Value:"499" });
                this.menu.crop.push({ Title:"李",Value:"624" });
                this.menu.crop.push({ Title:"桃",Value:"625" });
                this.menu.crop.push({ Title:"柿",Value:"626" });
                this.menu.crop.push({ Title:"蓮霧",Value:"628" });
                this.menu.crop.push({ Title:"巨峰葡萄",Value:"629" });
                this.menu.crop.push({ Title:"其他葡萄",Value:"633" });
                this.menu.crop.push({ Title:"枇杷",Value:"634" });
                this.menu.crop.push({ Title:"梅",Value:"635" });
                this.menu.crop.push({ Title:"荔枝",Value:"636" });
                this.menu.crop.push({ Title:"楊桃",Value:"638" });
                this.menu.crop.push({ Title:"梨",Value:"639" });
                this.menu.crop.push({ Title:"棗",Value:"641" });
                this.menu.crop.push({ Title:"百香果",Value:"643" });
                this.menu.crop.push({ Title:"人心果",Value:"645" });
                this.menu.crop.push({ Title:"可可椰子",Value:"646" });
                this.menu.crop.push({ Title:"可可",Value:"647" });
                this.menu.crop.push({ Title:"酪梨",Value:"648" });
                this.menu.crop.push({ Title:"紅龍果",Value:"651" });
                this.menu.crop.push({ Title:"番荔枝(大目種)",Value:"652" });
                this.menu.crop.push({ Title:"番荔枝(鳳梨釋迦)",Value:"653" });
                this.menu.crop.push({ Title:"其他果樹",Value:"698" });
                this.menu.crop.push({ Title:"桑",Value:"699" });
                this.menu.crop.push({ Title:"山藥",Value:"802" });
                this.menu.crop.push({ Title:"薄荷",Value:"804" });
                this.menu.crop.push({ Title:"其他藥用",Value:"811" });
                this.menu.crop.push({ Title:"洋菇",Value:"951" });
                this.menu.crop.push({ Title:"段木香菇",Value:"952" });
                this.menu.crop.push({ Title:"太空包香菇",Value:"953" });
                this.menu.crop.push({ Title:"木耳",Value:"955" });

            },
            //取得選單資訊(藉由Value)
            getMenuInfo:function(name,val)
            {
                var menu = null;
                var item = null;
                switch (name) {
                    case 'year':
                        //年度
                        menu = this.menu.year;
                    break;
                    case 'period':
                        //期作
                        menu = this.menu.period;
                    break;
                    case 'state':
                        //土地狀態
                        menu = this.menu.state;
                    break;
                    case 'town':
                        //行政區(已登記)
                        menu = this.menu.town;
                    break;
                    case 'town_all':
                        //行政區(未登記)
                        menu = this.menu.town_all;
                    break;
                    case 'crop':
                        //作物種類
                        menu = this.menu.crop;
                    break;
                    case 'modal.plant.menuSITESEC_NAME':
                        //地段(已登記)
                        menu = this.modal.plant.menuSITESEC_NAME;
                    break;
                    case 'modal.plant_all.menuSITESEC_NAME':
                        //地段(未登記)
                        menu = this.modal.plant_all.menuSITESEC_NAME;
                    break;
                    case 'modal.plant.menuSITESEC_NUMBER':
                        //地段
                        menu = this.modal.plant.menuSITESEC_NUMBER;
                    break;
                }

                if(menu == null)
                {
                    return null;
                }
                else
                {
                    for(var i=0 ; i < menu.length ; i++)
                    {
                        if(menu[i].Value == val)
                        {
                            item = menu[i];
                        }
                    }

                    return item;
                }
            },
            //取得地段清單(已登記)
            getSecList:function(TOWN_ID)
            {
                window.vue.modal.plant.valueCITY_ID = "P";
                window.vue.modal.plant.valueCITY_NAME = "雲林縣";

                window.vue.modal.plant.menuSITESEC_NAME = [];
                window.vue.modal.plant.valueSITESEC_NAME = "";

                var sitesec_list = [];
                for(var i=0 ; i<window.vue.form.verify.length ; i++)
                {
                    if(TOWN_ID == window.vue.form.verify[i].TOWN_ID)
                    {
                        sitesec_list = window.vue.form.verify[i].SITESEC;
                    }
                }

                for(var i2=0 ; i2<sitesec_list.length ; i2++)
                {
                    window.vue.modal.plant.menuSITESEC_NAME.push({

                        Title:sitesec_list[i2].SITESEC_NAME,
                        Value:sitesec_list[i2].SITESEC_NAME,
                        SITESEC_ID:sitesec_list[i2].SITESEC_ID,
                        SITESEC_CODE:sitesec_list[i2].SITESEC_CODE,
                        SITESEC_NAME:sitesec_list[i2].SITESEC_NAME
                    });
                }

            },
            //取得地段清單(未登記)
            getSecListAll:function(TOWN_ID)
            {
                this.enableDefaultLoad();
                this.apiGetSecList({

                    TOWN_ID:TOWN_ID,
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json;
                    if(data.State)
                    {
                        window.vue.modal.plant_all.valueCITY_ID = "P";
                        window.vue.modal.plant_all.valueCITY_NAME = "雲林縣";

                        window.vue.modal.plant_all.menuSITESEC_NAME = [];
                        window.vue.modal.plant_all.valueSITESEC_NAME = "";

                        for(var i=0 ; i<data.SITESEC_MENU.length ; i++)
                        {
                            window.vue.modal.plant_all.menuSITESEC_NAME.push({

                                Title:data.SITESEC_MENU[i].SITESEC_NAME,
                                Value:data.SITESEC_MENU[i].SITESEC_NAME,
                                SITESEC_ID:data.SITESEC_MENU[i].SITESEC_ID,
                                SITESEC_CODE:data.SITESEC_MENU[i].SITESEC_CODE,
                                SITESEC_NAME:data.SITESEC_MENU[i].SITESEC_NAME
                            });
                        }
                    }
                    else
                    {
                        alert(data.Message);
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },
            //取得作物清單
            getCropList:function(){
                this.enableDefaultLoad();
                this.apiGetCropList({

                })
                .then((res)=>{

                    const data = JSON.parse(res.data);
                    console.log(data);
                    this.menu.crop = [];

                    if(data.length > 0)
                    {
                        this.menu.crop.push({
                            Title:"休耕",
                            Value:"-1"
                        });

                        for(var i=0 ; i<data.length ; i++)
                        {
                            this.menu.crop.push({
                                Title:data[i].C_NAME,
                                Value:data[i].C_ID
                            });
                        }
                    }

                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },
            //取得最大種植面積
            getAreaMax:function(SITESEC_CODE,SITESEC_NUMBER)
            {
                this.enableDefaultLoad();
                this.apiGetAreaMax({

                    SITESEC_CODE:SITESEC_CODE,
                    SITESEC_NUMBER:SITESEC_NUMBER,
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json;
                    console.log(data);
                    if(data.length > 0)
                    {
                        if(this.modal.plant.moduleProcessSubmit == "add")
                        {
                            window.vue.modal.plant.valueAREA_P = data[0].AREA_P;
                        }
                        window.vue.modal.plant.maxAREA_P = data[0].AREA_P;
                    }
                    else
                    {
                        window.vue.modal.plant.valueAREA_P = "";
                        window.vue.modal.plant.maxAREA_P = "";
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },
            //取得已登記面積
            getAreaUse:function(YEAR,PERIOD,SITESEC_ID,SITESEC_NUMBER)
            {
                this.enableDefaultLoad();
                this.apiGetAreaUse({

                    YEAR:YEAR,
                    PERIOD:PERIOD,
                    SITESEC_ID:SITESEC_ID,
                    SITESEC_NUMBER:SITESEC_NUMBER
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json;
                    console.log(data);

                    window.vue.disableDefaultLoad();

                    if(data.length > 0)
                    {
                        var item = data[0];
                        var value = item.AREA_P;
                        if(value !== null && value !== '' && !isNaN(value))
                        {
                            var msg = "";
                            msg += this.modal.plant.valueA_YEAR + "年" + this.modal.plant.valuePERIOD + "\n";
                            msg += this.modal.plant.valueSITESEC_NAME + "-" + this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER) + "\n";
                            msg += "最大面積:" + window.vue.modal.plant.maxAREA_P + "公頃\n";
                            msg += "已登記:" + value + "公頃\n";
                            msg += "目前登記:" + Number(this.modal.plant.valueAREA_P) + "公頃\n";
                            msg += "操作失敗，已登記+目前登記已大於最大面積。"
                            console.log(window.vue.modal.plant.maxAREA_P);
                            console.log(value);
                            console.log(Number(this.modal.plant.valueAREA_P));

                            if((Number(this.modal.plant.valueAREA_P) + Number(value)) > Number(window.vue.modal.plant.maxAREA_P) )
                            {
                                alert(msg);
                                return false;
                            }
                        }

                        var itemTOWN_ID = this.getMenuInfo("town",this.modal.plant.valueTOWN_ID);
                        var itemCROP_ID = this.getMenuInfo("crop",this.modal.plant.valueCROP_ID);
                        var itemSITESEC_ID = this.getMenuInfo("modal.plant.menuSITESEC_NAME",this.modal.plant.valueSITESEC_NAME);

                        if(this.modal.plant.moduleProcessSubmit == "add")
                        {
                            this.plant.push({

                                CITY_ID:"P",
                                CITY_NAME:"雲林縣",
                                TOWN_ID:this.modal.plant.valueTOWN_ID,
                                TOWN_NAME:itemTOWN_ID.Title,
                                SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                                SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                                SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                                SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                                SITESEC_NUMBER_MENU:this.modal.plant.menuSITESEC_NUMBER,
                                CROP_ID:this.modal.plant.valueCROP_ID,
                                CROP_NAME:itemCROP_ID.Title,
                                A_YEAR:this.modal.plant.valueA_YEAR,
                                PERIOD:this.modal.plant.valuePERIOD,
                                STATE_P:this.modal.plant.valueSTATE_P,
                                AREA_P:Number(this.modal.plant.valueAREA_P),
                                DATE_P:this.modal.plant.valueDATE_P,
                                Type:"User",
                                Visibility:true,
                            });
                            this.modal.plant.modalStyleProcess.display = 'none';
                        }
                        else if(this.modal.plant.moduleProcessSubmit == "edit")
                        {
                            var key = this.modal.plant.indexProcessSubmit;

                            //直接覆蓋會有問題，他會影響隱藏、呈現功能，故改成Object.assign
                            Object.assign(this.plant[key], {

                                CITY_ID:"P",
                                CITY_NAME:"雲林縣",
                                TOWN_ID:this.modal.plant.valueTOWN_ID,
                                TOWN_NAME:itemTOWN_ID.Title,
                                SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                                SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                                SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                                SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                                SITESEC_NUMBER_MENU:this.modal.plant.menuSITESEC_NUMBER,
                                CROP_ID:this.modal.plant.valueCROP_ID,
                                CROP_NAME:itemCROP_ID.Title,
                                A_YEAR:this.modal.plant.valueA_YEAR,
                                PERIOD:this.modal.plant.valuePERIOD,
                                STATE_P:this.modal.plant.valueSTATE_P,
                                AREA_P:Number(this.modal.plant.valueAREA_P),
                                DATE_P:this.modal.plant.valueDATE_P,
                                Type:"User",
                                Visibility:true,
                            });
                            this.modal.plant.modalStyleProcess.display = 'none';
                        }

                    }

                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },
            //取得先前登記紀錄
            getAreaRecord:function()
            {
                this.enableDefaultLoad();
                this.apiGetAreaRecord({

                    UserName:this.form.valueUserName,
                    UserPhone:this.form.valueUserPhone
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    const data = json;
                    console.log(data);

                    if(data.length == 0){

                        alert("沒有登記紀錄。");
                    }else{

                        this.modal.record.menu = data;
                        this.modal.record.show = true;
                    }

                    window.vue.disableDefaultLoad();

                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },

            //取得使用者Xxx欄位未輸入訊息
            getPleaseEnterField: function(ParamName) { return "請輸入【" + ParamName + "】"; },
            //取得使用者Xxx欄位未選擇訊息
            getPleaseChooseField: function(ParamName) { return "請選擇【" + ParamName + "】"; },
            //取得使用者Xxx欄位為空訊息
            getErrorMessageParamEmpty: function(ParamName) { return "操作失敗，【" + ParamName + "】不可為空"; },
            //取得地號(修正，長度不足左邊補0)
            getSitesecNumber(sitesec_number){

                var sitesec_number_new = sitesec_number + "";
                if(sitesec_number_new.length < 8)
                {
                    sitesec_number_new = sitesec_number_new.padStart(8,'0');
                }
                return sitesec_number_new;
            },
            //取得圖層-面(實例:GeoJSON)
            getStandardVectorPlane:function(option){

            if(option == undefined || option == null){ option = {};  }

            /** 圖層樣式 */
            if(option.style == undefined || option.style == null){ option.style = null;  }
            /** 資料來源網址 */
            if(option.source_url == undefined || option.source_url == null){ option.source_url = "";  }
            /** 資料來源格式 */
            if(option.source_format == undefined || option.source_format == null){ option.source_format = new GeoJSON();  }
            /** 資料投影 */
            if(option.source_projection == undefined || option.source_projection == null){ option.source_projection = "EPSG:4326";  }


            /** 數據加載時 */
            if(option.onLoad == undefined || option.onLoad == null || typeof(option.onLoad) != 'function')
            {
                option.onLoad = function(aXMLHttpRequest){ console.log(aXMLHttpRequest); }
            }
            /** 程序錯誤時 */
            if(option.onError == undefined || option.onError == null || typeof(option.onError) != 'function')
            {
                option.onError = function(){ alert("加載失敗");  }
            }

            var mVector = new VectorLayer({

                style: option.style,
                source: new VectorSource({

                format: new GeoJSON(),
                projection: option.source_projection,
                loader: function (sourceExtent, resolution, projection) {

                    var mXMLHttpRequest = new XMLHttpRequest();
                    mXMLHttpRequest.open('GET', option.source_url);
                    mXMLHttpRequest.onerror = option.onError;
                    mXMLHttpRequest.onload = function () {

                    if (mXMLHttpRequest.status == 200)
                    {
                        var Param = {

                        XMLHttpRequest:mXMLHttpRequest,
                        SourceExtent:sourceExtent,
                        Resolution:resolution,
                        Projection:projection
                        }

                        option.onLoad(Param);
                    }
                    else
                    {
                        option.onError();
                    }

                    }
                    mXMLHttpRequest.send();

                }

                })

            });

            return mVector;
            },
            //設定QrCode
            setQrCode:function(qr_code){

                var url = this.qr_code_url + qr_code;

                document.getElementById("qr_code_img").innerHTML = "";
                new window.QRCode(document.getElementById("qr_code_img"), {
                    text : url,
                    width : 150,
                    height : 150
                });
            },
            //設定作物種植面積(雲林縣)
            setAgriSurveyAreaCityCrop:function()
            {
                var AgriSurveyArea = [];

                this.modal.statistics.titleSubChartCity = "";
                this.modal.statistics.allAreaChartCity = 0;

                var year = this.openLayers.Data.YunlinCity.A_YEAR;
                var city = this.openLayers.Data.YunlinCity.CITY;
                this.modal.statistics.titleSubChartCity = year + "年一期作" + city + "作物種植面積";

                var item = this.openLayers.Data.YunlinCity.CROP;

                for(var i=0 ; i<item.length ; i++)
                {
                    AgriSurveyArea.push({
                        CROP:item[i].NAME,
                        AREA_P:Number(item[i].AREA_P),
                    });
                    this.modal.statistics.allAreaChartCity += Number(item[i].AREA_P);
                }

                this.modal.statistics.allAreaChartCity = this.modal.statistics.allAreaChartCity.toFixed(2);

                if(AgriSurveyArea.length > 0)
                {
                    var data_area = [];
                    for(var i2=0 ; i2<AgriSurveyArea.length ; i2++)
                    {
                        data_area.push({
                            //縣市
                            x:AgriSurveyArea[i2].CROP,
                            //種植面積
                            y:this.getRounded(AgriSurveyArea[i2].AREA_P)
                        });
                    }

                    window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_city_crop);
                    window.vue.timeout_id_chart_city_crop = window.ThreadTool.Delay(function(){

                        window.setChartIntelligenceCropArea2("#chart_crop_area_city_crop",{
                            data:data_area,
                            chart:{
                                height:350 + (window.vue.openLayers.Data.YunlinCity.CROP.length * 25)
                            },
                        });

                    },this.delay_ms_chart);
                }

            },
            //設定鄉鎮種植面積(雲林縣)
            setAgriSurveyAreaCityTown:function()
            {
                var AgriSurveyArea = [];

                this.modal.statistics.titleSubChartCity = "";
                this.modal.statistics.allAreaChartCity = 0;

                var year = this.openLayers.Data.YunlinCity.A_YEAR;
                var city = this.openLayers.Data.YunlinCity.CITY;
                this.modal.statistics.titleSubChartCity = year + "年一期作" + city + "作物種植面積";

                var item = this.openLayers.Data.YunlinTown;

                for(var i=0 ; i<item.length ; i++)
                {
                    AgriSurveyArea.push({
                        TOWN:item[i].TOWN,
                        AREA_P:Number(item[i].AREA_P),
                    });
                    this.modal.statistics.allAreaChartCity += Number(item[i].AREA_P);
                }

                this.modal.statistics.allAreaChartCity = this.modal.statistics.allAreaChartCity.toFixed(2);

                if(AgriSurveyArea.length > 0)
                {
                    var data_area = [];
                    for(var i2=0 ; i2<AgriSurveyArea.length ; i2++)
                    {
                        data_area.push({
                            //縣市
                            x:AgriSurveyArea[i2].TOWN,
                            //種植面積
                            y:this.getRounded(AgriSurveyArea[i2].AREA_P)
                        });
                    }

                    window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_city_town);
                    window.vue.timeout_id_chart_city_town = window.ThreadTool.Delay(function(){

                        window.setChartIntelligenceCropArea3("#chart_crop_area_city_town",{
                            data:data_area,
                            chart:{
                                //height:350 + (window.vue.openLayers.Data.YunlinCity.CROP.length * 25)
                                height:350
                            },
                        });

                    },this.delay_ms_chart);
                }

            },
            //設定作物種植面積
            setAgriSurveyArea:function()
            {
                var TOWN_ID = this.openLayers.Select.YunlinTown;
                var AgriSurveyArea = [];

                this.modal.statistics.titleSubChartTown = "";
                this.modal.statistics.allAreaChartTown = 0;

                for(var i=0 ; i<this.openLayers.Data.YunlinTown.length ; i++)
                {
                    if(this.openLayers.Data.YunlinTown[i].TOWN_ID == TOWN_ID)
                    {

                        var year = this.openLayers.Data.YunlinTown[i].A_YEAR;
                        var town = this.openLayers.Data.YunlinTown[i].TOWN;
                        this.modal.statistics.titleSubChartTown = year + "年一期作" + town + "作物種植面積";

                        var item = this.openLayers.Data.YunlinTown[i].CROP;

                        for(var i2=0 ; i2<item.length ; i2++)
                        {
                            AgriSurveyArea.push({
                                CROP:item[i2].NAME,
                                AREA_P:Number(item[i2].AREA_P),
                            });
                            this.modal.statistics.allAreaChartTown += Number(item[i2].AREA_P);
                        }

                        this.modal.statistics.allAreaChartTown = this.modal.statistics.allAreaChartTown.toFixed(2);
                    }
                }

                if(AgriSurveyArea.length > 0)
                {
                    var data_area = [];
                    for(var i3=0 ; i3<AgriSurveyArea.length ; i3++)
                    {
                        data_area.push({
                            //縣市
                            x:AgriSurveyArea[i3].CROP,
                            //種植面積
                            y:this.getRounded(AgriSurveyArea[i3].AREA_P)
                        });
                    }

                    window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_town);
                    window.vue.timeout_id_chart_town = window.ThreadTool.Delay(function(){

                        window.setChartIntelligenceCropArea("#chart_crop_area_town",{
                            data:data_area
                        });
                        window.vue.openLayers.Map.updateSize();

                    },this.delay_ms_chart);
                }
            },


            //表單驗證
            onVerify:function(){

                if(this.isEmptyValue(this.form.valueUserName)){  alert(this.getErrorMessageParamEmpty("姓名")); return false; }
                //if(this.isEmptyValue(this.form.valueUserPhone)){  alert(this.getErrorMessageParamEmpty("電話")); return false; }
                if(this.isEmptyValue(this.form.valueUserPhone)){  alert(this.getErrorMessageParamEmpty("市話或手機號碼")); return false; }
                if(this.form.valueUserPhone.length < 6 ){alert("請輸入至少6碼的電話號碼。"); return false;}

                //驗證農民身分
                this.verifyAgriPlantUser();
            },
            //設定彈出視窗的作業模式(已登記)
            onSetModalProcessModule: function(module){

                if(module == "add"){

                    this.modal.plant.titleProcessSubmit = "新增";
                    this.modal.plant.btnProcessSubmit = "新增";
                    this.modal.plant.iconProcessSubmit = "fa-plus";
                    this.modal.plant.moduleProcessSubmit = module;

                }else if(module == "edit"){

                    this.modal.plant.titleProcessSubmit = "修改";
                    this.modal.plant.btnProcessSubmit = "修改";
                    this.modal.plant.iconProcessSubmit = "fa-paint-brush";
                    this.modal.plant.moduleProcessSubmit = module;
                }
            },
            // 設定彈出視窗的作業模式(未登記)
            onSetModalProcessModuleAll: function(module){

                if(module == "add"){

                    this.modal.plant_all.titleProcessSubmit = "新增";
                    this.modal.plant_all.btnProcessSubmit = "新增";
                    this.modal.plant_all.iconProcessSubmit = "fa-plus";
                    this.modal.plant_all.moduleProcessSubmit = module;

                }else if(module == "edit"){

                    this.modal.plant_all.titleProcessSubmit = "修改";
                    this.modal.plant_all.btnProcessSubmit = "修改";
                    this.modal.plant_all.iconProcessSubmit = "fa-paint-brush";
                    this.modal.plant_all.moduleProcessSubmit = module;
                }
            },
            //切換(已登記、未登記)
            onSwitch:function(val){

                if(val == "User")
                {
                    this.modal.plant.indexProcessSubmit = -1;
                    this.modal.plant.modalStyleProcess.display = 'block';

                    this.modal.plant_all.indexProcessSubmit = -1;
                    this.modal.plant_all.modalStyleProcess.display = "none";
                }
                else if(val == "All")
                {
                    this.modal.plant.indexProcessSubmit = -1;
                    this.modal.plant.modalStyleProcess.display = 'none';

                    this.modal.plant_all.indexProcessSubmit = -1;
                    this.modal.plant_all.modalStyleProcess.display = "block";
                }
            },
            //新增(已登記)
            onInsert:function(){

                //因為新增有切換功能，所以一起設定
                this.onClearModalProcess();
                this.onSetModalProcessModule("add");
                this.onClearModalProcessAll();
                this.onSetModalProcessModuleAll("add");
                this.modal.plant.indexProcessSubmit = -1;

                if(this.form.isVerifyPass)
                {
                    this.modal.plant_all.modalStyleProcess.display = "block";
                }
                else
                {
                    this.modal.plant.modalStyleProcess.display = "block";
                }
            },
            //新增(未登記)
            onInsertAll:function(){

                //因為新增有切換功能，所以一起設定
                this.onClearModalProcess();
                this.onSetModalProcessModule("add");
                this.onClearModalProcessAll();
                this.onSetModalProcessModuleAll("add");
                this.modal.plant_all.indexProcessSubmit = -1;
                this.modal.plant_all.modalStyleProcess.display = "block";
            },
            // 修改
            onModify:function(value,key){

                console.log(value);

                if(value.Type == "User")
                {
                    this.onClearModalProcess();
                    this.onSetModalProcessModule("edit");
                    this.modal.plant.indexProcessSubmit = key;
                    this.modal.plant.modalStyleProcess.display = "block";

                    //種植情況-鄉鎮市區
                    this.modal.plant.valueTOWN_ID = "";
                    this.modal.plant.passWatchTOWN_ID = true;
                    this.modal.plant.valueTOWN_ID = value.TOWN_ID;
                    //種植情況-地段
                    this.modal.plant.valueSITESEC_NAME = "";
                    this.modal.plant.passWatchSITESEC_NAME = true;
                    this.modal.plant.valueSITESEC_NAME = value.SITESEC_NAME;
                    //種植情況-地段(選單)
                    this.modal.plant.menuSITESEC_NAME = value.SITESEC_MENU;
                    //種植情況-地號
                    this.modal.plant.valueSITESEC_NUMBER = "";
                    this.modal.plant.valueSITESEC_NUMBER_BEFORE = value.SITESEC_NUMBER.substr(0,4);
                    this.modal.plant.valueSITESEC_NUMBER_AFTER = value.SITESEC_NUMBER.substr(4,4);
                    this.modal.plant.valueSITESEC_NUMBER = this.getSitesecNumber(value.SITESEC_NUMBER);
                    //種植情況-地號(選單)
                    this.modal.plant.menuSITESEC_NUMBER = value.SITESEC_NUMBER_MENU;
                    //種植情況-作物種類
                    this.modal.plant.valueCROP_ID = value.CROP_ID;
                    //種植情況-年度
                    this.modal.plant.valueA_YEAR = value.A_YEAR;
                    //種植情況-期作
                    this.modal.plant.valuePERIOD = value.PERIOD;
                    //種植情況-土地狀態
                    this.modal.plant.valueSTATE_P = value.STATE_P;
                    //種植情況-種植面積
                    this.modal.plant.valueAREA_P = value.AREA_P;
                    //種植情況-種植日期
                    this.modal.plant.valueDATE_P = value.DATE_P;
                }
                else if(value.Type == "All")
                {
                    this.onClearModalProcessAll();
                    this.onSetModalProcessModuleAll("edit");
                    this.modal.plant_all.indexProcessSubmit = key;
                    this.modal.plant_all.modalStyleProcess.display = "block";

                    //種植情況-鄉鎮市區
                    this.modal.plant_all.valueTOWN_ID = "";
                    this.modal.plant_all.passWatchTOWN_ID = true;
                    this.modal.plant_all.valueTOWN_ID = value.TOWN_ID;
                    //種植情況-地段
                    this.modal.plant_all.valueSITESEC_NAME = "";
                    this.modal.plant_all.passWatchSITESEC_NAME = true;
                    this.modal.plant_all.valueSITESEC_NAME = value.SITESEC_NAME;
                    //種植情況-地段(選單)
                    this.modal.plant_all.menuSITESEC_NAME = value.SITESEC_MENU;
                    //種植情況-地號
                    this.modal.plant_all.valueSITESEC_NUMBER = "";
                    this.modal.plant_all.valueSITESEC_NUMBER_BEFORE = value.SITESEC_NUMBER.substr(0,4);
                    this.modal.plant_all.valueSITESEC_NUMBER_AFTER = value.SITESEC_NUMBER.substr(4,4);
                    this.modal.plant_all.valueSITESEC_NUMBER = this.getSitesecNumber(value.SITESEC_NUMBER);
                    //種植情況-地號(選單)
                    this.modal.plant_all.menuSITESEC_NUMBER = value.SITESEC_NUMBER_MENU;
                    //種植情況-作物種類
                    this.modal.plant_all.valueCROP_ID = value.CROP_ID;
                    //種植情況-年度
                    this.modal.plant_all.valueA_YEAR = value.A_YEAR;
                    //種植情況-期作
                    this.modal.plant_all.valuePERIOD = value.PERIOD;
                    //種植情況-土地狀態
                    this.modal.plant_all.valueSTATE_P = value.STATE_P;
                    //種植情況-種植面積
                    this.modal.plant_all.valueAREA_P = value.AREA_P;
                    //種植情況-種植日期
                    this.modal.plant_all.valueDATE_P = value.DATE_P;
                }
            },
            // 儲存(已登記)(新增、修改、瀏覽 點選視窗下面的按鈕)
            onSava: function () {

                //新增或修改 都要驗證欄位
                if(this.modal.plant.moduleProcessSubmit == "add" || this.modal.plant.moduleProcessSubmit == "edit")
                {
                    if(this.modal.plant.valueTOWN_ID == null){ this.modal.plant.valueTOWN_ID == ""; }
                    if(this.modal.plant.valueSITESEC_NAME == null){ this.modal.plant.valueSITESEC_NAME == ""; }

                    if(this.modal.plant.valueTOWN_ID == ""){  alert(this.getPleaseChooseField("鄉鎮市區"));  return false; }
                    if(this.modal.plant.valueSITESEC_NAME == ""){  alert(this.getPleaseChooseField("地段"));  return false; }
                    if(this.modal.plant.valueSITESEC_NUMBER == ""){  alert(this.getPleaseEnterField("地號"));  return false; }
                    if(this.modal.plant.valueSITESEC_NUMBER.length != 8){  alert("請輸入完整的地號，前4碼-後4碼 (共8碼)。");  return false; }
                    if(this.modal.plant.maxAREA_P == ""){  alert("沒有該地號資料，請確認是否輸入正確。");  return false; }

                    if(this.modal.plant.valueA_YEAR == ""){  alert(this.getPleaseChooseField("年度"));  return false; }
                    if(this.modal.plant.valuePERIOD == ""){  alert(this.getPleaseChooseField("期作"));  return false; }
                    //if(this.modal.plant.valueSTATE_P == ""){  alert(this.getPleaseChooseField("土地狀態"));  return false; }

                    if(this.modal.plant.valueCROP_ID == ""){  alert(this.getPleaseChooseField("作物種類"));  return false; }
                    if(this.modal.plant.valueAREA_P == ""){  alert(this.getPleaseEnterField("種植面積"));  return false; }

                    if(Number(this.modal.plant.valueAREA_P) <= Number(this.modal.plant.minAREA_P)){  alert("【種植面積】必須大於" + this.modal.plant.minAREA_P + "公頃");  return false; }
                    if(Number(this.modal.plant.valueAREA_P) > Number(this.modal.plant.maxAREA_P)){  alert("【種植面積】必須小於等於" + this.modal.plant.maxAREA_P + "公頃");  return false; }

                    if(this.modal.plant.valueDATE_P == ""){  alert(this.getPleaseChooseField("種植日期"));  return false; }

                }

                var itemSITESEC_ID = window.vue.getMenuInfo("modal.plant.menuSITESEC_NAME",window.vue.modal.plant.valueSITESEC_NAME);
                this.getAreaUse(this.modal.plant.valueA_YEAR,this.modal.plant.valuePERIOD,itemSITESEC_ID.SITESEC_ID,this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER));

                /*
                var itemTOWN_ID = this.getMenuInfo("town",this.modal.plant.valueTOWN_ID);
                var itemCROP_ID = this.getMenuInfo("crop",this.modal.plant.valueCROP_ID);
                var itemSITESEC_ID = this.getMenuInfo("modal.plant.menuSITESEC_NAME",this.modal.plant.valueSITESEC_NAME);

                if(this.modal.plant.moduleProcessSubmit == "add")
                {
                    this.plant.push({

                        CITY_ID:"P",
                        CITY_NAME:"雲林縣",
                        TOWN_ID:this.modal.plant.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                        SITESEC_NUMBER_MENU:this.modal.plant.menuSITESEC_NUMBER,
                        CROP_ID:this.modal.plant.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant.valueA_YEAR,
                        PERIOD:this.modal.plant.valuePERIOD,
                        STATE_P:this.modal.plant.valueSTATE_P,
                        AREA_P:Number(this.modal.plant.valueAREA_P),
                        DATE_P:this.modal.plant.valueDATE_P,
                        Type:"User",
                        Visibility:true,
                    });
                    this.modal.plant.modalStyleProcess.display = 'none';
                }
                else if(this.modal.plant.moduleProcessSubmit == "edit")
                {
                    var key = this.modal.plant.indexProcessSubmit;

                    //直接覆蓋會有問題，他會影響隱藏、呈現功能，故改成Object.assign
                    Object.assign(this.plant[key], {

                        CITY_ID:"P",
                        CITY_NAME:"雲林縣",
                        TOWN_ID:this.modal.plant.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant.valueSITESEC_NUMBER),
                        SITESEC_NUMBER_MENU:this.modal.plant.menuSITESEC_NUMBER,
                        CROP_ID:this.modal.plant.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant.valueA_YEAR,
                        PERIOD:this.modal.plant.valuePERIOD,
                        STATE_P:this.modal.plant.valueSTATE_P,
                        AREA_P:Number(this.modal.plant.valueAREA_P),
                        DATE_P:this.modal.plant.valueDATE_P,
                        Type:"User",
                        Visibility:true,
                    });
                    this.modal.plant.modalStyleProcess.display = 'none';
                }
                */
            },
            // 儲存(未登記)(新增、修改、瀏覽 點選視窗下面的按鈕)
            onSavaAll: function () {

                //新增或修改 都要驗證欄位
                if(this.modal.plant_all.moduleProcessSubmit == "add" || this.modal.plant_all.moduleProcessSubmit == "edit")
                {
                    if(this.modal.plant_all.valueTOWN_ID == null){ this.modal.plant_all.valueTOWN_ID == ""; }
                    if(this.modal.plant_all.valueSITESEC_NAME == null){ this.modal.plant_all.valueSITESEC_NAME == ""; }

                    if(this.modal.plant_all.valueTOWN_ID == ""){  alert(this.getPleaseChooseField("鄉鎮市區"));  return false; }
                    if(this.modal.plant_all.valueSITESEC_NAME == ""){  alert(this.getPleaseChooseField("地段"));  return false; }
                    if(this.modal.plant_all.valueSITESEC_NUMBER == ""){  alert(this.getPleaseEnterField("地號22"));  return false; }
                    if(this.modal.plant_all.valueSITESEC_NUMBER.length != 8){  alert("請輸入完整的地號，前4碼-後4碼 (共8碼)。");  return false; }

                    if(this.modal.plant_all.valueA_YEAR == ""){  alert(this.getPleaseChooseField("年度"));  return false; }
                    if(this.modal.plant_all.valuePERIOD == ""){  alert(this.getPleaseChooseField("期作"));  return false; }
                    //if(this.modal.plant_all.valueSTATE_P == ""){  alert(this.getPleaseChooseField("土地狀態"));  return false; }

                    if(this.modal.plant_all.valueCROP_ID == ""){  alert(this.getPleaseChooseField("作物種類"));  return false; }
                    if(this.modal.plant_all.valueAREA_P == ""){  alert(this.getPleaseEnterField("種植面積"));  return false; }

                    if(Number(this.modal.plant_all.valueAREA_P) <= Number(this.modal.plant_all.minAREA_P)){  alert("【種植面積】必須大於" + this.modal.plant_all.minAREA_P + "公頃");  return false; }

                    if(this.modal.plant_all.valueDATE_P == ""){  alert(this.getPleaseChooseField("種植日期"));  return false; }
                }

                var itemTOWN_ID = this.getMenuInfo("town_all",this.modal.plant_all.valueTOWN_ID);
                var itemCROP_ID = this.getMenuInfo("crop",this.modal.plant_all.valueCROP_ID);
                var itemSITESEC_ID = this.getMenuInfo("modal.plant_all.menuSITESEC_NAME",this.modal.plant_all.valueSITESEC_NAME);

                if(this.modal.plant_all.moduleProcessSubmit == "add")
                {
                    this.plant.push({

                        CITY_ID:"P",
                        CITY_NAME:"雲林縣",
                        TOWN_ID:this.modal.plant_all.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant_all.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant_all.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant_all.valueSITESEC_NUMBER),
                        SITESEC_NUMBER_MENU:this.modal.plant_all.menuSITESEC_NUMBER,
                        CROP_ID:this.modal.plant_all.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant_all.valueA_YEAR,
                        PERIOD:this.modal.plant_all.valuePERIOD,
                        STATE_P:this.modal.plant_all.valueSTATE_P,
                        AREA_P:Number(this.modal.plant_all.valueAREA_P),
                        DATE_P:this.modal.plant_all.valueDATE_P,
                        Type:"All",
                        Visibility:true,
                    });
                    this.modal.plant_all.modalStyleProcess.display = 'none';
                }
                else if(this.modal.plant_all.moduleProcessSubmit == "edit")
                {
                    var key = this.modal.plant_all.indexProcessSubmit;
                    this.plant[key] = {

                        CITY_ID:"P",
                        CITY_NAME:"雲林縣",
                        TOWN_ID:this.modal.plant_all.valueTOWN_ID,
                        TOWN_NAME:itemTOWN_ID.Title,
                        SITESEC_ID:itemSITESEC_ID.SITESEC_ID,
                        SITESEC_NAME:this.modal.plant_all.valueSITESEC_NAME,
                        SITESEC_MENU:this.modal.plant_all.menuSITESEC_NAME,
                        SITESEC_NUMBER:this.getSitesecNumber(this.modal.plant_all.valueSITESEC_NUMBER),
                        SITESEC_NUMBER_MENU:this.modal.plant_all.menuSITESEC_NUMBER,
                        CROP_ID:this.modal.plant_all.valueCROP_ID,
                        CROP_NAME:itemCROP_ID.Title,
                        A_YEAR:this.modal.plant_all.valueA_YEAR,
                        PERIOD:this.modal.plant_all.valuePERIOD,
                        STATE_P:this.modal.plant_all.valueSTATE_P,
                        AREA_P:Number(this.modal.plant_all.valueAREA_P),
                        DATE_P:this.modal.plant_all.valueDATE_P,
                        Type:"All",
                        Visibility:true,
                    };
                    this.modal.plant_all.modalStyleProcess.display = 'none';
                }

            },
            // 刪除
            onDelete: function (key) {

                var yes = confirm(this.message.plantConfirmDelete);

                if (yes)
                {
                    //你按了確定按鈕
                    this.plant.splice(key, 1);
                } else {
                    //你按了取消按鈕
                }
            },
            // 提交
            onSubmit: function(){

                if(this.isEmptyValue(this.form.valueUserName)){  alert(this.getErrorMessageParamEmpty("姓名")); return false; }
                //if(this.isEmptyValue(this.form.valueUserPhone)){  alert(this.getErrorMessageParamEmpty("電話")); return false; }
                if(this.isEmptyValue(this.form.valueUserPhone)){  alert(this.getErrorMessageParamEmpty("市話或手機號碼")); return false; }
                if(this.form.valueUserPhone.length < 6 ){alert("請輸入至少6碼的電話號碼。"); return false;}
                if(!this.form.isVerifyDone){ alert(this.message.plantSubmitVerifyNone); return false; }
                if(this.plant.length == 0){ alert(this.message.plantEmptyAlert); return false; }
                var yes = confirm(this.message.plantConfirmSubmit);
                if (yes)
                {
                    //你按了確定按鈕
                    this.plantRegister();
                }
                else
                {
                    //你按了取消按鈕
                }
            },
            // 呈現、隱藏項目
            onVisibility: function (key,visibility)
            {
                this.plant[key].Visibility = visibility;
            },
            // 清空彈出視窗的所有欄位
            onClearModalProcess:function(){

                var mNowDate = new Date();

                //種植情況-鄉鎮市區
                this.modal.plant.valueTOWN_ID = "";
                //種植情況-地段
                this.modal.plant.valueSITESEC_NAME = "";
                //種植情況-地段(選單)
                this.modal.plant.menuSITESEC_NAME = [];
                //種植情況-地號
                this.modal.plant.valueSITESEC_NUMBER = "";
                this.modal.plant.valueSITESEC_NUMBER_BEFORE = "";
                this.modal.plant.valueSITESEC_NUMBER_AFTER = "";
                //種植情況-地號(選單)
                this.modal.plant.menuSITESEC_NUMBER = [];
                //種植情況-作物種類
                this.modal.plant.valueCROP_ID = "";
                //種植情況-年度 (預設今年度)
                this.modal.plant.valueA_YEAR = mNowDate.getFullYear() - 1911;
                //種植情況-期作
                this.modal.plant.valuePERIOD = "";
                //種植情況-土地狀態
                this.modal.plant.valueSTATE_P = "";
                //種植情況-種植面積
                this.modal.plant.valueAREA_P = "";
                //種植情況-種植日期
                this.modal.plant.valueDATE_P = "";
            },
            // 清空彈出視窗的所有欄位
            onClearModalProcessAll:function(){

                var mNowDate = new Date();

                //種植情況-鄉鎮市區
                this.modal.plant_all.valueTOWN_ID = "";
                //種植情況-地段
                this.modal.plant_all.valueSITESEC_NAME = "";
                //種植情況-地段(選單)
                this.modal.plant_all.menuSITESEC_NAME = [];
                //種植情況-地號
                this.modal.plant_all.valueSITESEC_NUMBER = "";
                this.modal.plant_all.valueSITESEC_NUMBER_BEFORE = "";
                this.modal.plant_all.valueSITESEC_NUMBER_AFTER = "";
                //種植情況-地號(選單)
                this.modal.plant_all.menuSITESEC_NUMBER = [];
                //種植情況-作物種類
                this.modal.plant_all.valueCROP_ID = "";
                //種植情況-年度 (預設今年度)
                this.modal.plant_all.valueA_YEAR = mNowDate.getFullYear() - 1911;
                //種植情況-期作
                this.modal.plant_all.valuePERIOD = "";
                //種植情況-土地狀態
                this.modal.plant_all.valueSTATE_P = "";
                //種植情況-種植面積
                this.modal.plant_all.valueAREA_P = "";
                //種植情況-種植日期
                this.modal.plant_all.valueDATE_P = "";
            },
            // 下載QrCode圖片
            onDownloadQrCode:function(){

                //藉型別陣列建構的 blob 來建立 URL
                var link = document.createElement("a");
                document.body.appendChild(link);
                //因為部分瀏覽器，他的img src 可能是因為 base64 所以取不到資料，他會是如下情形(目前所知，Android  chrome手機板 會有這個問題，但切換到電腦版卻不會)
                //<img alt="Scan me!" style="display: block;">
                //link.href = document.querySelector("#qr_code_img img").src;
                //link.href = document.querySelector("#qr_code_img img").src.replace(/(\r\n)|(\n)|(\r)/g, '');
                //暫時先改成這樣
                const canvas = document.querySelector("#qr_code_img canvas");
                link.href = canvas.toDataURL();
                link.download = "qr_code.png";
                link.click();
               //this.downloadBase64(document.querySelector("#qr_code_img img").src);
            },
            // 重新登記
            onAgainRegister:function(){

                /*
                var yes = confirm(this.message.qrCodeConfirmAgainRegister);
                if (yes)
                {
                    //你按了確定按鈕
                    this.plant = [];
                    this.form.isSubmitDone = false;
                }
                else
                {
                    //你按了取消按鈕
                }
                */
                this.plant = [];
                this.form.isSubmitDone = false;
            },
            downloadBase64:function (base64) {
                var arr = base64.split(',');
                var bytes = atob(arr[1]);
                let ab = new ArrayBuffer(bytes.length);
                let ia = new Uint8Array(ab);
                for (let i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                var blob = new Blob([ab], { type: 'application/octet-stream' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "qr_code.png";
                var e = document.createEvent('MouseEvents');
                e.initMouseEvent(
                    'click',
                    true,
                    false,
                    window,
                    0,
                    0,
                    0,
                    0,
                    0,
                    false,
                    false,
                    false,
                    false,
                    0,
                    null
                );
                a.dispatchEvent(e);
                URL.revokeObjectURL(url);
            },
            // 初始(地圖)
            initMap: function () {

                const _this = this;
                //正射影像圖(通用)
                this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        url: "https://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                });
                //臺灣通用電子地圖(無鐵公路)
                this.openLayers.Layer.Tile.EMAP9 = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        url: "https://wmts.nlsc.gov.tw/wmts/EMAP/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                });
                //村里界圖
                this.openLayers.Layer.Tile.Village = new Tile({
                    minZoom: 7,
                    maxZoom: 18,
                    source: new XYZ({
                        //縣市界
                        //url: "https://wmts.nlsc.gov.tw/wmts/CITY/default/EPSG:3857/{z}/{y}/{x}"
                        //鄉鎮區界
                        //url: "https://wmts.nlsc.gov.tw/wmts/TOWN/default/EPSG:3857/{z}/{y}/{x}"
                        //村里界圖
                        url: "https://wmts.nlsc.gov.tw/wmts/Village/default/EPSG:3857/{z}/{y}/{x}"
                        //地段外圍圖(後期可以考慮這個，這個直接把地段名稱、地段識別碼(範例:奮起段PD0424)秀出來)
                        //url: "https://wmts.nlsc.gov.tw/wmts/LANDSECT/default/EPSG:3857/{z}/{y}/{x}"

                    }),
                });
                //雲林行政區
                this.openLayers.Layer.YunlinTown = this.getStandardVectorPlane({

                    style: this.openLayers.Style.YunlinTown,
                    source_url: "GeoJSON/yunlin.geojson",
                    //source_projection:"EPSG:3826",
                    onLoad:function(Param){

                        var mResponseText = Param.XMLHttpRequest.responseText;
                        //若坐標系是TWD97請用這個
                        //var mFeatures = (new GeoJSON()).readFeatures(mResponseText);

                        //若坐標系是經緯度請用這個
                        var mFeatures = (new GeoJSON()).readFeatures(mResponseText,{ featureProjection: Param.Projection });
                        _this.openLayers.Layer.YunlinTown.getSource().addFeatures(mFeatures);
                    }
                });
                this.openLayers.Layer.YunlinTown.set("LayerId", "openLayers.Layer.YunlinTown");

                //圖台
                this.openLayers.Map = new Map({
                    target: _this.openLayers.Default.Target,
                    layers: [
                        //臺灣通用電子地圖(無鐵公路)
                        this.openLayers.Layer.Tile.EMAP9,
                        //村里界圖
                        //this.openLayers.Layer.Tile.Village,
                    ],
                    view: new View({
                        minZoom: 7,
                        maxZoom: 18,
                        center: fromLonLat([_this.openLayers.Default.CenterLng, _this.openLayers.Default.CenterLat]),
                        zoom: _this.openLayers.Default.Zoom
                    })
                });

                this.openLayers.Map.addLayer(this.openLayers.Layer.YunlinTown);

                if(this.openLayers.Data.YunlinTown.length > 0)
                {
                    this.openLayers.Select.YunlinTown = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                    this.openLayers.Layer.YunlinTown.getSource().changed();
                    this.setAgriSurveyArea();
                }


                /** 註冊監聽事件-當滑鼠單擊時 */
                this.openLayers.Map.on('click', function (e) {

                    var pixel = e.pixel;
                    var click_event = [];

                    //取得所以被觸發的圖層，並將它堆疊再一起
                    _this.openLayers.Map.forEachFeatureAtPixel(pixel, function(feature, layer)
                    {
                        click_event.push({feature:feature,layer:layer});
                    });

                    if(click_event.length > 0)
                    {
                        //僅取第一個被觸發的圖層
                        var mLayer = click_event[0].layer;
                        var mFeature = click_event[0].feature;
                        var mLayerId = mLayer.get("LayerId");

                        switch(mLayerId){

                            case 'openLayers.Layer.YunlinTown':

                                for(var i=0 ; i<_this.openLayers.Data.YunlinTown.length ; i++)
                                {
                                    //若有在清單內，才觸發
                                    if(_this.openLayers.Data.YunlinTown[i].TOWN_ID == mFeature.values_.County_ID)
                                    {
                                        _this.openLayers.Select.YunlinTown = mFeature.values_.County_ID;
                                        _this.openLayers.Layer.YunlinTown.getSource().changed();
                                        _this.setAgriSurveyArea();
                                    }
                                }
                            break;
                        default:
                        }
                    }

                });

                /** 註冊監聽事件-當滑鼠放開時 */
                this.openLayers.Map.on('moveend', function (e) {

                    console.log(e);
                    window.vue.valueProcessZOOM = window.vue.openLayers.Map.getView().getZoom();
                });
            },
            //切換圖層(state=true 加入地圖、state=false 從地圖移除)
            switchLayer: function(layer,state){

                if(state)
                {
                    this.openLayers.Map.addLayer(layer);
                }
                else
                {
                    this.openLayers.Map.removeLayer(layer);
                }
            },
            //驗證農民身分
            verifyAgriPlantUser:function(){
                this.enableDefaultLoad();
                this.apiVerifyAgriPlantUser({

                    UserName:this.form.valueUserName,
                    Keyword:this.form.valueUserPhone,
                })
                .then((res)=>{

                    const data = JSON.parse(res.data);
                    this.menu.town = [];

                    console.log(data);

                    //匯入使用者已登記的行政區
                    for(var i=0 ; i < data.length ;i++)
                    {
                        var item = data[i];
                        this.menu.town.push({ Title:item.TOWN,Value:item.TOWN_ID});
                    }

                    this.form.verify = data;
                    if(this.form.verify.length == 0)
                    {
                        //alert(this.message.verifyError);
                        //this.form.isVerifyDone = false;
                        let answer = confirm('驗證失敗，你是否願意放棄驗證直接登記?');
                        if(answer)
                        {
                            //選擇確定
                            this.form.isVerifyDone = true;
                            this.form.isVerifyPass = true;
                            //取得各選單
                            this.getMenuList();
                        }else{
                            //選擇取消
                            this.form.isVerifyDone = false;
                            this.form.isVerifyPass = false;
                        }
                    }
                    else
                    {
                        alert(this.message.verifyDone);
                        this.form.isVerifyDone = true;
                        //取得各選單
                        this.getMenuList();
                        //範本資料
                        /*
                        this.form.verify = [

                            {
                                TOWN:"虎尾鎮",
                                TOWN_ID:"P03",
                                SITESEC:[
                                    {
                                        NAME:"虎尾段",
                                        ID:"PD0400",
                                        LIST:[
                                            {
                                                NUMBER:"00000001",
                                                AREA: 0.1,
                                            },
                                            {
                                                NUMBER:"00000002",
                                                AREA: 0.3,
                                            },
                                            {
                                                NUMBER:"00000003",
                                                AREA: 0.5,
                                            },
                                            {
                                                NUMBER:"00000004",
                                                AREA: 0.7,
                                            },
                                        ],
                                    },
                                    {
                                        NAME:"埒內段",
                                        ID:"PD0401",
                                        LIST:[
                                            {
                                                NUMBER:"00000005",
                                                AREA: 0.5,
                                            },
                                            {
                                                NUMBER:"00000006",
                                                AREA: 0.6,
                                            },
                                            {
                                                NUMBER:"00000007",
                                                AREA: 0.7,
                                            }
                                        ],
                                    },
                                ]
                            },
                            {
                                TOWN:"西螺鎮",
                                TOWN_ID:"P04",
                                SITESEC:[
                                    {
                                        NAME:"西螺段",
                                        ID:"PC0300",
                                        LIST:[
                                            {
                                                NUMBER:"00000007",
                                                AREA: 2,
                                            },
                                            {
                                                NUMBER:"00000008",
                                                AREA: 3,
                                            },
                                            {
                                                NUMBER:"00000009",
                                                AREA: 5,
                                            },
                                            {
                                                NUMBER:"00000010",
                                                AREA: 7,
                                            },
                                        ],
                                    },
                                    {
                                        NAME:"茄苳段",
                                        ID:"PC0301",
                                        LIST:[
                                            {
                                                NUMBER:"00000005",
                                                AREA: 0.5,
                                            },
                                            {
                                                NUMBER:"00000006",
                                                AREA: 0.6,
                                            },
                                            {
                                                NUMBER:"00000007",
                                                AREA: 0.7,
                                            }
                                        ],
                                    },
                                ]
                            },
                        ];
                        */
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },
            //種植紀錄提交
            plantRegister:function(){

                this.enableDefaultLoad();

                if(this.form.isVerifyPass)
                {
                    this.apiPlantRegister({

                        UserName:window.vue.form.valueUserName,
                        UserPhone:window.vue.form.valueUserPhone,
                        Plant:window.vue.plant,
                        Mark:"尚未驗證"
                    })
                    .then((res)=>{

                        window.vue.setQrCode(res.data);
                        window.vue.form.isSubmitDone = true;
                        window.vue.disableDefaultLoad();
                    })
                    .catch((err)=> {
                        console.log(err);
                        window.vue.disableDefaultLoad();
                    });
                }
                else
                {
                    this.apiPlantRegister({

                        UserName:window.vue.form.valueUserName,
                        UserPhone:window.vue.form.valueUserPhone,
                        Plant:window.vue.plant
                    })
                    .then((res)=>{

                        window.vue.setQrCode(res.data);
                        window.vue.form.isSubmitDone = true;
                        window.vue.disableDefaultLoad();
                    })
                    .catch((err)=> {
                        console.log(err);
                        window.vue.disableDefaultLoad();
                    });

                }



            },
            //種植統計數據
            plantStatistics:function(){
                this.enableDefaultLoad();
                this.apiPlantStatistics({

                })
                .then((res)=>{

                    const data = JSON.parse(res.data);
                    console.log(data);
                    if(data.TownPlantStatistics.length > 0)
                    {
                        this.modal.statistics.show = true;
                        this.openLayers.Data.YunlinCity = data.CityPlantStatistics;
                        this.openLayers.Data.YunlinTown = data.TownPlantStatistics;
                        this.openLayers.Select.YunlinTown = this.openLayers.Data.YunlinTown[0].TOWN_ID;
                        this.openLayers.Layer.YunlinTown.getSource().changed();
                        this.setAgriSurveyArea();
                        this.setAgriSurveyAreaCityCrop();
                        this.setAgriSurveyAreaCityTown();

                    }else{

                        alert("目前沒有任何種植登記紀錄");
                    }

                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                });
            },

        },
    }

</script>
<style scoped>


[v-cloak] {

    display: none;

}

/** 下拉選單 */
select
{
    height: 30px;
}

/** 必填欄位 */
.required
{
    color: #FF0000;
}

/** 彈出視窗 */
/** 整行 */
.w3-modal .w3-row
{
    margin-top: 10px;
}

/** 表單及清單 */
#plant_register
{
    text-align: -webkit-center;
}

/** 表單 */
#plant_form
{
    max-width: 600px;
}
/** 表單-標頭 */
#plant_form .header-title
{
    font-size: 20px;
    margin-top: 20px !important;
}
/** 表單-欄位 */
#plant_form .field
{
    width:100px;
}

/** 清單 */
#plant_list
{
    max-width: 600px;
    padding-bottom: 10px;
}
/** 清單-項目 */
#plant_list .item
{
    margin: 10px;
}
/** 清單-標頭 */
#plant_list .header-title
{
    text-align:right;
    font-weight: 500;
}
/** 清單-農民登記資訊 */
#plant_list .info
{
    text-align:left;
    border-bottom:1px #CCC solid; padding-bottom:1px;
}
/** 清單-農民登記資訊 欄位 */
#plant_list .info .field
{
    font-weight: 400;
    color:#000000;
}
/** 清單-農民登記資訊 數值 */
#plant_list .info .value
{
    color:#000093;
    font-style:oblique;
}

/** 新增、送出按鈕群 */
.plant_btns_insert_send
{
    text-align:right;
    max-width: 600px;
    padding-right: 10px;
}

/** 目前共有 n 筆種植紀錄 */
.plant_amount
{
    color:#844200;
    max-width: 600px;
    font-weight: 500;
    padding-left: 10px;
    text-align:left;
}

/** 清單為空訊息 */
#plant_empty_message
{
    max-width: 600px;
}

/** 清單為空訊息 標頭 */
#plant_empty_message .header-title
{
    margin-top: 30px !important;
    font-size: 1.2rem;
    padding-left: 25px;
    padding-right: 25px;
    text-align:left;
}

/** 清單為空訊息 描述 */
#plant_empty_message .description
{
    font-size: 16px;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 1rem;
    text-align: left;
}

/** 領取獎勵 */
#receive_award
{
    text-align: -webkit-center;
}

/** QrCode */
#qr_code
{
    max-width: 450px;
    text-align: -webkit-center;
}



/** 兌換表單 */
#award_form
{
    text-align: -webkit-center;
}

#award_form .page
{
    max-width: 450px;
}

/** 公用表單畫面 */
.form-style
{
    min-height: 360px;
}
/** 公用表單畫面-標頭 */
.form-style .header-title
{
    margin-top: 30px !important;
    font-weight: bold;
    font-size: 1.75rem;
}
/** 公用表單畫面-圖片 */
.form-style .img-body
{
    width:30%;
    min-width: 150px !important;
}
/** 公用表單畫面-描述 */
.form-style .description
{
    margin-top: 20px !important;
    font-size: 1.2rem;
}

/** 新增、修改彈出視窗 內容 */
#dialog_register .body
{
    max-width: 560px;
}

/** 新增、修改彈出視窗 欄位 */
#dialog_register .field
{
    text-align:right;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 8px;
    padding-right: 3px;
    width:35%;
}

/** 新增、修改彈出視窗 數值 */
#dialog_register .value
{
    width:65%;
    padding: 5px;
}


/** 圖台 */
#map
{
    height: 300px;
}

/** 圖表 */
#chart_crop_area_town
{
    height: 300px;
}


</style>
